/* tslint:disable max-line-length */
import * as React from 'react';
import { SvgIcon } from '@material-ui/core';

export function ToriiLogo(...props: any) {
  const iconProps = props[0];
  return (
    <svg
      width={40}
      height={36}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...iconProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.458.68c.16-.102.391-.1.55.005.461.304 1.653 1.004 4.596 2.418 3.683 1.77 11.79 2.264 14.137 2.373h.529c.217 0 .378.192.348.406l-.812 5.718a.348.348 0 01-.344.306h-2.484c-.847-.027-8.812-.316-12.221-1.772-2.635-1.125-3.581-1.639-3.9-1.834a.299.299 0 00-.3-.003c-.327.195-1.298.715-3.942 1.844-3.41 1.457-11.271 1.738-12.12 1.765H1.159a.348.348 0 01-.344-.306L.003 5.882a.356.356 0 01.152-.345c.013-.009.007-.035-.01-.035.054-.001.105-.015.158-.022a.36.36 0 01.05-.004h.45c2.341-.108 10.33-.596 14.01-2.364 2.955-1.42 4.172-2.127 4.645-2.431z"
        fill="#463264"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.058 8.336h6.54l-1.546 27.208H4.048l2.01-27.208zM33.546 8.408h-6.54l1.546 27.207h7.004l-2.01-27.207z"
        fill="#463264"
      />
    </svg>
  );
}

export function Bicycling(...props: any) {
  const iconProps = props[0];
  return (
    <SvgIcon viewBox="0 0 57 47" {...iconProps}>
      <path d="M42.2 4.1c0-2.2-1.9-4.1-4.2-4.1 -2.4 0-4.2 1.8-4.2 4.1s1.9 4.1 4.2 4.1C40.3 8.1 42.2 6.3 42.2 4.1zM32.7 35.7C32.7 42 37.9 47 44.5 47s11.8-5 11.8-11.3c0-6.2-5.3-11.3-11.8-11.3S32.7 29.5 32.7 35.7zM36.7 35.4c0-4.3 3.7-7.9 8.3-7.9s8.3 3.5 8.3 7.9 -3.7 7.9-8.3 7.9S36.7 39.8 36.7 35.4zM44.7 19.4v-4.1h-7.6L32.5 8c-0.7-1.1-2-1.9-3.4-1.9 -1.1 0-2.1 0.4-2.8 1.1l-8.7 8.3c-0.8 0.7-1.2 1.6-1.2 2.7 0 1.4 0.8 2.6 2 3.3l7.9 4.6v11.3h4.2V22.8l-5.3-3.8 5.5-5.2 4.1 5.6H44.7zM0 35.7C0 42 5.3 47 11.8 47s11.8-5 11.8-11.3c0-6.2-5.3-11.3-11.8-11.3S0 29.5 0 35.7zM3.1 35.4c0-4.3 3.7-7.9 8.3-7.9 4.6 0 8.3 3.5 8.3 7.9s-3.7 7.9-8.3 7.9C6.8 43.3 3.1 39.8 3.1 35.4z" />
    </SvgIcon>
  );
}

export function Driving(...props: any) {
  const iconProps = props[0];
  return (
    <SvgIcon viewBox="0 0 50 43" {...iconProps}>
      <path d="M40.3 0H9.7C7.9 0 6.4 1.1 5.8 2.7L0 18.8v21.5C0 41.8 1.2 43 2.8 43h2.8c1.5 0 2.8-1.2 2.8-2.7v-2.7h33.3v2.7c0 1.5 1.2 2.7 2.8 2.7h2.8c1.5 0 2.8-1.2 2.8-2.7V18.8L44.2 2.7C43.7 1.1 42.1 0 40.3 0zM6 25.5C6 23 8 21 10.5 21s4.5 2 4.5 4.5S13 30 10.5 30 6 28 6 25.5zM37 25.5c0-2.5 2-4.5 4.5-4.5s4.5 2 4.5 4.5S44 30 41.5 30 37 28 37 25.5zM10.2 4h30.6L45 16H6L10.2 4z" />
    </SvgIcon>
  );
}

export function FavoriteEmpty(...props: any) {
  const iconStyle = props.small
    ? { height: 18, width: 19 }
    : { height: 24, width: 25 };
  return (
    <SvgIcon viewBox="0 0 25 24" style={iconStyle}>
      <path
        d="M12.5 22.4L14 21c8.4-7.7 10.5-10.3 10.5-14.1 0-3.6-2.8-6.4-6.4-6.4-2 0-3.9.9-5.2 2.4l-.4.4-.4-.4C10.8 1.4 8.8.5 6.9.5 3.3.5.5 3.3.5 6.9.5 10.8 2.6 13.3 11 21l1.5 1.4z"
        fillOpacity={0.5}
        stroke="#fff"
        fill="rgba(0,0,0,0.65)"
      />
    </SvgIcon>
  );
}

export function FavoriteFull(props: any) {
  const iconStyle = props.small
    ? { height: 18, width: 19 }
    : { height: 24, width: 25 };
  return (
    <SvgIcon x="0px" y="0px" viewBox="0 0 25 24" style={iconStyle}>
      <path
        d="M17.4.5c1.7 0 3.2.7 4.3 1.8 1.1 1.1 1.8 2.6 1.8 4.3 0 4.4-4.1 8-10.1 13.5h0L12 21.3 10.6 20C4.6 14.6.5 11 .5 6.5c0-1.7.7-3.2 1.8-4.3C3.4 1.1 4.9.4 6.6.4c1.9 0 3.8.9 5 2.3.1.3.3.4.4.6.1-.2.2-.3.4-.5 1.2-1.4 3-2.3 5-2.3z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#195a50"
        stroke="#fff"
      />
    </SvgIcon>
  );
}

export function ListIcon(...props: any) {
  const iconProps = props[0];
  return (
    <SvgIcon viewBox="0 0 23 20" width="1em" height="1em" {...iconProps}>
      <path
        d="M5 12.1h12.7v-1.4H5v1.4zM5 15h12.7v-1.4H5V15zm0-5.7h12.7V7.9H5v1.4zM5 5v1.4h12.7V5H5z"
        fill="#323232"
      />
    </SvgIcon>
  );
}

export function MapExtendIcon(...props: any) {
  const iconProps = props[0];
  return (
    <svg viewBox="0 0 14 14" width="14" height="14" {...iconProps}>
      <path
        d="M2 9H0v5h5v-2H2V9zM0 5h2V2h3V0H0v5zm12 7H9v2h5V9h-2v3zM9 0v2h3v3h2V0H9z"
        fill="#323232"
      />
    </svg>
  );
}

export function MapContractIcon(...props: any) {
  const iconProps = props[0];
  return (
    <svg viewBox="0 0 14 14" width="14" height="14" {...iconProps}>
      <path
        d="M0 11h3v3h2V9H0v2zm3-8H0v2h5V0H3v3zm6 11h2v-3h3V9H9v5zm2-11V0H9v5h5V3h-3z"
        fill="#323232"
      />
    </svg>
  );
}

export function Star(...props: any) {
  const iconProps = props[0];
  return (
    <SvgIcon viewBox="0 0 23 22" {...iconProps}>
      <g transform="translate(-145, -16)">
        <polygon points="156.5 34.2419513 149.392609 38 150.75 30.0403252 145 24.4032522 152.946305 23.2419513 156.5 16 160.053695 23.2419513 168 24.4032522 162.25 30.0403252 163.607391 38" />
      </g>
    </SvgIcon>
  );
}

export function Transit(...props: any) {
  const iconProps = props[0];
  return (
    <SvgIcon viewBox="0 0 40 45" {...iconProps}>
      <path d="M0 9.5V32c0 4.6 3.9 8.3 8.8 8.3L5 43.8V45h30v-1.2l-3.8-3.6c4.8 0 8.8-3.7 8.8-8.3V9.5C40 1.2 31 0 20 0S0 1.2 0 9.5zM5 31.5C5 29.6 6.6 28 8.5 28s3.5 1.6 3.5 3.5S10.4 35 8.5 35 5 33.4 5 31.5zM5 21V9h13v12H5zM27 31.5c0-1.9 1.6-3.5 3.5-3.5s3.5 1.6 3.5 3.5S32.4 35 30.5 35 27 33.4 27 31.5zM22 21V9h13v12H22z" />
    </SvgIcon>
  );
}

export function Walking(...props: any) {
  const iconProps = props[0];
  return (
    <SvgIcon viewBox="0 0 29 46" {...iconProps}>
      <path d="M17.7 7.6c2.2 0 4-1.7 4-3.8S19.9 0 17.7 0s-4 1.7-4 3.8S15.5 7.6 17.7 7.6L17.7 7.6zM18 20.7h10.8v-3.8h-8l-4.4-7c-0.7-1.1-1.9-1.8-3.2-1.8 -0.4 0-0.8 0.1-1.1 0.1L0 11.8v11h4V15l4.7-1.4L0 46h4l6.4-17.1 5.2 6.6V46h4V32.5L14 22.9l1.6-6.1L18 20.7 18 20.7z" />
    </SvgIcon>
  );
}

export function ToriiBotWarning(...props: any) {
  const iconProps = props[0];
  return (
    <svg viewBox="0 0 199 197" height={197} width={199} {...props}>
      <path
        fill="#E9ECF4"
        d="M72.6 121.6c10.3 0 18.8.4 25.4 1.2 6.9.9 12.3 6.4 12.9 13.3l2.1 22c1.7 18.7-12.1 35.2-30.8 37-.7.1-1.5.1-2.2.1-2.5.2-4.9.2-7.4.2v-73.8z"
      />
      <linearGradient
        id="a"
        gradientUnits="userSpaceOnUse"
        x1={-740.5039}
        y1={655.3596}
        x2={-740.5153}
        y2={655.19}
        gradientTransform="matrix(126.3826 0 0 -230.6533 93679.102 151317.875)"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopOpacity={0.05} />
      </linearGradient>
      <path
        fill="url(#a)"
        d="M72.6 121.6c10.3 0 18.8.4 25.4 1.2 6.9.9 12.3 6.4 12.9 13.3l2.1 22c1.7 18.7-12.1 35.2-30.8 37-.7.1-1.5.1-2.2.1-2.5.2-4.9.2-7.4.2v-73.8z"
      />
      <path
        fill="#FFF"
        d="M47.3 122.8c6.6-.8 14.9-1.2 25.4-1.2v73.8c-2.5 0-4.9 0-7.3-.1-18.8-.5-33.6-16.1-33-34.9 0-.7.1-1.5.1-2.2l2.1-22c.5-7 5.8-12.6 12.7-13.4z"
      />
      <linearGradient
        id="b"
        gradientUnits="userSpaceOnUse"
        x1={-739.8126}
        y1={655.3589}
        x2={-739.824}
        y2={655.1893}
        gradientTransform="matrix(126.3759 0 0 -230.6533 93547.695 151317.875)"
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={1} stopOpacity={0.05} />
      </linearGradient>
      <path
        fill="url(#b)"
        d="M47.3 122.8c6.6-.8 14.9-1.2 25.4-1.2v73.8c-2.5 0-4.9 0-7.3-.1-18.8-.5-33.6-16.1-33-34.9 0-.7.1-1.5.1-2.2l2.1-22c.5-7 5.8-12.6 12.7-13.4z"
      />
      <radialGradient
        id="c"
        cx={-643.5748}
        cy={678.9742}
        r={0.9698}
        gradientTransform="matrix(0 6.994 41.6699 0 -28219.662 4622.713)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopOpacity={0.25} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </radialGradient>
      <path
        fill="url(#c)"
        d="M73.1 128.4c17.4 0 30.4-1.1 30.4-3.2 0-2.2-11.9-3.6-30.6-3.6s-30.7 1.2-30.7 3.4 13.5 3.4 30.9 3.4z"
      />
      <linearGradient
        id="d"
        gradientUnits="userSpaceOnUse"
        x1={-723.0726}
        y1={628.0616}
        x2={-723.3925}
        y2={627.7418}
        gradientTransform="matrix(60.1332 0 0 -60.1332 43515.523 37913.543)"
      >
        <stop offset={0} stopColor="#e8eef5" />
        <stop offset={1} stopColor="#bec7d8" />
      </linearGradient>
      <ellipse fill="url(#d)" cx={25.2} cy={155.8} rx={9.6} ry={9.6} />
      <linearGradient
        id="e"
        gradientUnits="userSpaceOnUse"
        x1={-726.7847}
        y1={626.976}
        x2={-727.1046}
        y2={626.6562}
        gradientTransform="matrix(60.1332 0 0 -60.1332 43843.578 37817.469)"
      >
        <stop offset={0} stopColor="#e8eef5" />
        <stop offset={1} stopColor="#bec7d8" />
      </linearGradient>
      <ellipse fill="url(#e)" cx={130.1} cy={125} rx={9.6} ry={9.6} />
      <linearGradient
        id="f"
        gradientUnits="userSpaceOnUse"
        x1={-702.9794}
        y1={759.8404}
        x2={-702.9794}
        y2={759.5206}
        gradientTransform="matrix(0 49.206 18.4523 0 -13944.228 34614.988)"
      >
        <stop offset={0} stopColor="#e8eef5" />
        <stop offset={1} stopColor="#bec7d8" />
      </linearGradient>
      <path fill="url(#f)" d="M76.1 16.3L76.6 32.1 70.7 32.1 71.2 16.3z" />
      <radialGradient
        id="g"
        cx={-719.39}
        cy={617.2043}
        r={1.2812}
        gradientTransform="matrix(16.2227 0 0 -16.229 11744.049 10028.757)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#ffbcbc" />
        <stop offset={1} stopColor="red" />
      </radialGradient>
      <ellipse fill="url(#g)" cx={73.6} cy={12.2} rx={7.9} ry={7.9} />
      <linearGradient
        id="h"
        gradientUnits="userSpaceOnUse"
        x1={-710.3124}
        y1={642.7981}
        x2={-710.3124}
        y2={642.4783}
        gradientTransform="matrix(43.0553 0 0 -107.6382 30593.406 69245.29)"
      >
        <stop offset={0} stopColor="#e8eef5" />
        <stop offset={1} stopColor="#bec7d8" />
      </linearGradient>
      <path
        fill="url(#h)"
        d="M7.3 58l10.2-2.4V90L7.3 87.7c-1-.2-1.9-1-2.2-2-.9-2.9-1.4-7.2-1.4-12.8 0-5.6.5-9.9 1.4-12.8.4-1.1 1.2-1.8 2.2-2.1z"
      />
      <linearGradient
        id="i"
        gradientUnits="userSpaceOnUse"
        x1={-791.4672}
        y1={687.2021}
        x2={-791.4672}
        y2={687.5222}
        gradientTransform="matrix(-43.0553 0 0 107.6382 -33940.313 -73913.54)"
      >
        <stop offset={0} stopColor="#e8eef5" />
        <stop offset={1} stopColor="#bec7d8" />
      </linearGradient>
      <path
        fill="url(#i)"
        d="M139.9 87.7l-10.2 2.4V55.7l10.2 2.4c1 .2 1.9 1 2.2 2 .9 2.9 1.4 7.2 1.4 12.8 0 5.6-.5 9.9-1.4 12.8-.3 1.1-1.1 1.8-2.2 2z"
      />
      <path
        fill="#FFF"
        d="M38.2 33.2c10.1-.8 21.9-1.2 35.4-1.2v82.6c-13.1 0-24.7-.5-34.7-1.6-12.2-1.3-21.6-11.2-22-23.5l-1.3-30.9C15 45.5 25 34.2 38.2 33.2z"
      />
      <path
        fill="#E9ECF4"
        d="M109 33.2C98.9 32.4 87.1 32 73.6 32v82.6c13.1 0 24.7-.5 34.7-1.6 12.2-1.3 21.6-11.2 22-23.5l1.3-30.9c.6-13.1-9.4-24.4-22.6-25.4z"
      />
      <path
        fill="#21324A"
        d="M38.3 41.4c11.8-1.7 23.6-2.5 35.3-2.5s23.5.8 35.3 2.5c10.1 1.4 17.5 10.2 17 20.5l-1.5 29.2c-.3 6.1-4.3 11.3-10 13.3-9 2.9-22.5 4.5-40.7 4.5s-31.8-1.5-40.7-4.5c-5.8-2-9.7-7.2-10-13.3l-1.5-29.2c-.6-10.3 6.8-19.1 16.8-20.5z"
      />
      <path
        fill="#FFF"
        d="M64.2 84.1h19.3c0 4.9-4 9-9 9h-1.4c-4.9 0-8.9-4.1-8.9-9z"
      />
      <ellipse fill="#195a50" cx={99.1} cy={73.4} rx={6.9} ry={6.9} />
      <ellipse fill="#195a50" cx={48.1} cy={73.4} rx={6.9} ry={6.9} />
      <path
        fill="#F2F2F2"
        d="M141.9 83.4l6.4 1.7-15 55.8c-.5 1.8-2.3 2.8-4 2.4-1.8-.5-2.7-2.3-2.4-4l15-55.9z"
      />
      <path
        fill="#FC2D2D"
        fillOpacity={0.7496}
        stroke="#FFF"
        strokeWidth={5}
        d="M149.8 4.4l-27.8 16-8.3 31 16 27.8 31 8.3 27.8-16 8.2-31-16-27.7-30.9-8.4z"
      />
      <path
        fill="#FFF"
        d="M173.3 35.5c-1.6-.4-2.9.6-3.4 2l-2.1 7.8-1.1 3.9-1.8-.5 1.3-4.6 3.4-12.4c.4-1.5-.5-3-2-3.5-1.6-.4-2.9.6-3.4 2l-1.9 6.9-2.3 8.4-1.8-.5 2.4-9 2.7-9.9c.4-1.5-.5-3-2-3.5-1.6-.4-2.9.6-3.4 2l-4.3 15.9-1.3 4.6-1.8-.5 1.2-4.5 3.4-12.6c.4-1.5-.5-3-2-3.5-1.6-.4-2.9.6-3.4 2l-4.9 18.3c-2.5-4.9-6-10.2-8.4-8.9-2.5 1.5.9 8.2 4.5 21.8 1.8 6.3 4.6 10.8 11.3 12.7 7.2 2 14.8-2.6 16.8-9.9l1.5-5.7 4.2-15.8c.9-1 0-2.7-1.4-3z"
      />
      <path
        fill="#FF7350"
        d="M76.2 157c5 2.5 10.6 3.1 16.3 2.1.5-.1 1-.4 1.3-.8.3-.4.5-.9.5-1.4v-1.7c0-1.3-.3-2.6-.8-3.7-.5-1.2-1.3-2.2-2.3-3L76.8 136c-1.2-1-2.7-1.6-4.2-1.6s-3 .5-4.2 1.6l-4.7 4c-.4.3-.6.7-.7 1.2-.1.5-.1 1 .1 1.4 3 6.4 7.3 11.5 13.1 14.4"
      />
      <path
        fill="#FFA0BE"
        d="M66.9 163.2c-.4-6.1-3.1-11.8-7.4-16.7-.4-.4-.9-.7-1.5-.7s-1.1.1-1.6.5l-2.5 2.1c-1 .8-1.8 1.9-2.3 3-.5 1.2-.8 2.5-.8 3.7v19.4c0 1.8.7 3.5 1.9 4.7 1.2 1.2 2.9 2 4.6 2h2.5c.5 0 1-.1 1.5-.4.4-.3.8-.6 1.1-1.1 3.3-5.1 4.9-10.8 4.5-16.5"
      />
      <path
        fill="#463264"
        d="M77.2 168.3c-3.5 2.4-6.3 5.7-8.3 9.6-.2.4-.3.7-.3 1.1s.1.8.3 1.1c.2.3.5.6.8.8.3.2.7.3 1.1.3h17c1.7 0 3.4-.7 4.6-2 1.2-1.2 1.9-2.9 1.9-4.7V166c0-.3-.1-.6-.2-.9-.1-.3-.3-.5-.5-.7-.2-.2-.4-.4-.7-.5-.3-.1-.5-.2-.8-.2-5.4.2-10.5 1.6-14.9 4.6"
      />
    </svg>
  );
}

export function DarkBlueMarker(...props: any) {
  const iconProps = props[0];
  return (
    <svg viewBox="0 0 53 26" cursor="pointer" {...iconProps}>
      <path
        d="M44 2c5 0 9 4 9 9s-4 9-9 9H28.6l-3.2 6-3.2-6H9c-5 0-9-4-9-9s4-9 9-9h35z"
        fillOpacity={0.5}
        id="dark-blue-marker"
      />
      <path
        d="M44 0c5 0 9 4 9 9s-4 9-9 9H28.6l-3.2 6-3.2-6H9c-5 0-9-4-9-9s4-9 9-9h35z"
        fill="#C8BDDB"
        id="dark-blue-marker"
      />
      <text
        fill="#ffff"
        fontFamily="Lato"
        fontSize={14}
        textAnchor="middle"
        x="50%"
        y="50%"
        id="dark-blue-marker"
      >
        {iconProps.content}
      </text>
    </svg>
  );
}

export function BlueMarker(...props: any) {
  const iconProps = props[0];
  return (
    <svg viewBox="0 0 53 26" cursor="pointer" {...iconProps}>
      <path
        d="M44.2 2c5 0 9 4 9 9s-4 9-9 9H28.8l-3.2 6-3.2-6H9.2c-5 0-9-4-9-9s4-9 9-9h35z"
        fillOpacity={0.5}
        id="blue-marker"
      />
      <path
        d="M44.2 0c5 0 9 4 9 9s-4 9-9 9H28.8l-3.2 6-3.2-6H9.2c-5 0-9-4-9-9s4-9 9-9h35z"
        fill="#463264"
        id="blue-marker"
      />
      <text
        fill="#ffff"
        fontFamily="Lato"
        fontSize={14}
        fontWeight="bold"
        textAnchor="middle"
        x="50%"
        y="50%"
        id="blue-marker"
      >
        {iconProps.content}
      </text>
    </svg>
  );
}

export function GreenMarker(...props: any) {
  const iconProps = props[0];
  return (
    <svg viewBox="0 0 53 26" cursor="pointer" {...iconProps}>
      <path
        d="M44 2c5 0 9 4 9 9s-4 9-9 9H28.6l-3.2 6-3.2-6H9c-5 0-9-4-9-9s4-9 9-9h35z"
        fillOpacity={0.5}
        id="green-marker"
      />
      <path
        d="M44 0c5 0 9 4 9 9s-4 9-9 9H28.6l-3.2 6-3.2-6H9c-5 0-9-4-9-9s4-9 9-9h35z"
        fill="#195a50"
        id="green-marker"
      />
      <text
        fill="#ffff"
        fontFamily="Lato"
        fontSize={14}
        fontWeight="bold"
        textAnchor="middle"
        x="50%"
        y="50%"
        id="green-marker"
      >
        {iconProps.content}
      </text>
    </svg>
  );
}

export function FavoriteMarker(...props: any) {
  const iconProps = props[0];
  return (
    <SvgIcon viewBox="0 0 25 24" cursor="pointer" {...iconProps}>
      <path
        d="M12.5 22.4L14 21c8.4-7.7 10.5-10.3 10.5-14.1 0-3.6-2.8-6.4-6.4-6.4-2 0-3.9.9-5.2 2.4l-.4.4-.4-.4C10.8 1.4 8.8.5 6.9.5 3.3.5.5 3.3.5 6.9.5 10.8 2.6 13.3 11 21l1.5 1.4z"
        fill="#195a50"
        stroke="#fff"
      />
    </SvgIcon>
  );
}

export function ToriiGate(...props: any) {
  const iconProps = props[0];
  return (
    <SvgIcon viewBox="0 0 46 40" {...iconProps}>
      <path
        d="M4.1 13H1.4c-.2 0-.4-.2-.4-.4L.1 6.1c0-.2.1-.4.3-.4H.2h1C8.6 5.4 14 4.5 17.2 3 20.1 1.6 21.9.7 22.6.2c.1-.1.3-.1.5 0 .7.5 2.5 1.4 5.4 2.8 3.2 1.5 8.6 2.4 16.2 2.7h.8c.2 0 .4.2.4.4v.1l-.9 6.5c0 .2-.2.3-.4.3h-2.9c-6.6-.2-11.3-.9-14.1-2-2.5-1.1-4-1.8-4.5-2.1-.1-.1-.2-.1-.3 0-.6.4-2.1 1.1-4.6 2.1-2.8 1.1-7.5 1.8-14.1 2z"
        fill="#463264"
      />
      <path
        d="M7.1 9h7.6l-1.8 30.5c0 .2-.2.4-.4.4H5.2c-.2 0-.4-.2-.4-.4L7.1 9zM38.9 9h-7.6l1.8 30.5c0 .2.2.4.4.4h7.3c.2 0 .4-.2.4-.4L38.9 9z"
        fill="#463264"
      />
    </SvgIcon>
  );
}

export function ContactIcon(...props: any) {
  const iconProps = props[0];
  return (
    <SvgIcon viewBox="0 0 15 12" style={{ width: '0.7em' }} {...iconProps}>
      <path
        d="M13.6 0H1.4C.6 0 0 .6 0 1.4v8.9c0 .8.6 1.4 1.4 1.4h12.1c.8 0 1.4-.6 1.4-1.4V1.4C15 .6 14.4 0 13.6 0zm-.2 3L7.5 7 1.6 3V1.6l5.9 3.9 5.9-3.9V3z"
        fill="#757575"
      />
    </SvgIcon>
  );
}

export function FaqIcon(...props: any) {
  const iconProps = props[0];
  return (
    <SvgIcon viewBox="0 0 15 16" style={{ width: '0.7em' }} {...iconProps}>
      <path
        d="M7.5.5C3.4.5 0 3.9 0 8s3.4 7.5 7.5 7.5S15 12.1 15 8 11.6.5 7.5.5zm.8 11.3H6.7V7.2h1.5v4.6zm0-6H6.7V4.2h1.5v1.6z"
        fill="#757575"
      />
    </SvgIcon>
  );
}

export function MeetingIcon(...props: any) {
  const iconProps = props[0];
  return (
    <SvgIcon viewBox="0 0 15 16" style={{ width: '0.7em' }} {...iconProps}>
      <path
        d="M11.9 8.6H8.1v3.8h3.8V8.6zM10.6.5v1.2H4.4V.5H2.5v1.2h-.9C.7 1.8 0 2.5 0 3.3v10.6c0 .9.7 1.6 1.6 1.6h11.9c.9 0 1.6-.7 1.6-1.6V3.3c0-.9-.7-1.6-1.6-1.6h-.9V.5h-2zm2.8 13.4H1.6V5.7h11.9v8.2z"
        fill="#757575"
      />
    </SvgIcon>
  );
}

export function PreApprovalIcon(...props: any) {
  const iconProps = props[0];
  return (
    <SvgIcon viewBox="0 0 9 16" style={{ width: '0.7em' }} {...iconProps}>
      <text
        transform="translate(-.14 14)"
        fill="#757575"
        fontWeight="bold"
        fontSize={12}
      >
        {'$'}
      </text>
    </SvgIcon>
  );
}

export function SearchIcon(...props: any) {
  const iconProps = props[0];
  return (
    <SvgIcon viewBox="0 0 15 16" style={{ width: '0.7em' }} {...iconProps}>
      <path
        d="M10.7 9.9H10l-.3-.2c.8-1 1.3-2.2 1.3-3.6C11 3 8.5.5 5.4.5 2.5.5 0 3 0 6.1s2.5 5.6 5.6 5.6c1.4 0 2.6-.5 3.6-1.3l.3.2v.7l4.3 4.3 1.3-1.3-4.4-4.4zm-5.1 0C3.5 9.9 1.8 8.2 1.8 6c0-2.1 1.7-3.9 3.8-3.9 2.1 0 3.8 1.7 3.8 3.9S7.7 9.9 5.6 9.9z"
        fill="#757575"
      />
    </SvgIcon>
  );
}

export function SignInIcon(...props: any) {
  const iconProps = props[0];
  return (
    <SvgIcon viewBox="0 0 15 16" style={{ width: '0.7em' }} {...iconProps}>
      <path
        d="M7.5.5C6 .5 4.5 1 3.2 1.9 2 2.7 1 3.9.5 5.3l-.1.4H2l.1-.2c.3-.6.7-1.2 1.2-1.7C4.4 2.7 5.9 2 7.5 2s3.1.6 4.2 1.7 1.7 2.6 1.7 4.2-.6 3.1-1.7 4.2S9.1 14 7.5 14s-3.1-.6-4.2-1.7c-.5-.5-.9-1.1-1.2-1.7l-.1-.3H.4l.1.4c.5 1.4 1.5 2.6 2.7 3.4 1.3.9 2.8 1.4 4.3 1.4 4.1 0 7.5-3.4 7.5-7.5S11.6.5 7.5.5z"
        fill="#757575"
      />
      <path
        fill="#757575"
        d="M0 8.8h6.8l-1.5 1.6 1 1.1L9.8 8 6.3 4.5 5.2 5.6l1.6 1.6H0z"
      />
    </SvgIcon>
  );
}

export function SignUpIcon(...props: any) {
  const iconProps = props[0];
  return (
    <SvgIcon viewBox="0 0 15 12" style={{ width: '0.7em' }} {...iconProps}>
      <path
        d="M9 6c1.7 0 3-1.4 3-3s-1.3-3-3-3-3 1.4-3 3 1.3 3 3 3zm0 1.5c-2 0-6 1-6 3V12h12v-1.5c0-2-4-3-6-3zM3 5V3H2v2H0v1h2v2h1V6h2V5H3z"
        fill="#757575"
      />
    </SvgIcon>
  );
}

export function ToolsIcon(...props: any) {
  const iconProps = props[0];
  return (
    <SvgIcon viewBox="0 0 15 16" style={{ width: '0.7em' }} {...iconProps}>
      <path
        d="M14.8 12.8L6.6 5s.3-1.9.9-2.4c.6-.5 1.6-1.1 1.6-1.1v-1c-1.1 0-2 .3-3.2.9C4.6 2 3.6 3 3.4 3.3c-.3.3-.6.7-.8 1-.3.3-.2.6-.2.6l-.7.6-.1-.2c-.1-.1-.2-.1-.3 0L.1 6.6c-.1.1-.1.2 0 .3l2 2c.1.1.2.1.3 0l1.2-1.2c.1-.1.1-.2 0-.3L3.2 7l.5-.5c.2-.1.9-.3 1.3-.2l7.2 8.9c.3.3.7.3 1 0l1.6-1.6c.3-.2.3-.6 0-.8z"
        fill="#757575"
      />
    </SvgIcon>
  );
}

export function NewMarkerIcon(...props: any) {
  const iconProps = props[0];
  return (
    <svg viewBox="0 0 32 17" {...iconProps} transform="translate(0 -2)">
      <path
        fillOpacity={0.5}
        d="M1.8,3.2h28.5c0.6,0,1,0.4,1,1v10.5c0,0.6-0.4,1-1,1H1.8c-0.6,0-1-0.4-1-1V4.2C0.8,3.7,1.2,3.2,1.8,3.2z"
      />
      <path
        fill="#E2658C"
        stroke="#FFFFFF"
        strokeWidth={0.5}
        d="M1.8,1.2h28.5c0.6,0,1,0.4,1,1v10.5c0,0.6-0.4,1-1,1H1.8c-0.6,0-1-0.4-1-1V2.2C0.8,1.7,1.2,1.2,1.8,1.2z"
      />
      <text
        transform="translate(6.5 10)"
        fill="#fff"
        fontSize={8}
        style={{ fontFamily: 'Lato', fontWeight: 'bold' }}
      >
        NEW
      </text>
    </svg>
  );
}

export function FiveStars(props: any) {
  const iconProps = props.small ? { width: 100 } : { width: 200 };
  return (
    <svg viewBox="0 0 195 34" style={iconProps}>
      <path
        fill="#fabc21"
        d="M17.5 26.7l10.8 6.6L25.5 21l9.5-8.3-12.6-1.1L17.5 0l-4.9 11.6L0 12.7 9.5 21 6.7 33.3zM57.5 26.7l10.8 6.6L65.5 21l9.5-8.3-12.6-1.1L57.5 0l-4.9 11.6L40 12.7l9.5 8.3-2.8 12.3zM97.5 26.7l10.8 6.6-2.8-12.3 9.5-8.3-12.6-1.1L97.5 0l-4.9 11.6L80 12.7l9.5 8.3-2.8 12.3zM137.5 26.7l10.8 6.6-2.8-12.3 9.5-8.3-12.6-1.1L137.5 0l-4.9 11.6-12.6 1.1 9.5 8.3-2.8 12.3zM177.5 26.7l10.8 6.6-2.8-12.3 9.5-8.3-12.6-1.1L177.5 0l-4.9 11.6-12.6 1.1 9.5 8.3-2.8 12.3z"
      />
    </svg>
  );
}

export function CheckMark(props: any) {
  return (
    <svg viewBox="0 0 100 76" style={props.iconStyle}>
      <path
        d="M2.3 38.4c2.9-2.9 7.7-2.9 10.6 0l19.4 19.4L87.1 3C90 .1 94.8.1 97.7 3s2.9 7.7 0 10.6l-60 60.1c-2.9 2.9-7.7 2.9-10.6 0L2.3 49c-3-2.9-3-7.7 0-10.6z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#195a50"
      />
    </svg>
  );
}

export function BackIcon(props: any) {
  return (
    <svg
      viewBox="0 0 25 25"
      style={{ height: 25, width: 25, ...props.iconStyle }}
    >
      <path
        d="M12.5 24.9c6.9 0 12.5-5.6 12.5-12.5C24.9 5.6 19.3 0 12.5 0S0 5.6 0 12.5c0 6.8 5.6 12.4 12.5 12.4zm0-23.2c5.9 0 10.7 4.8 10.7 10.7s-4.8 10.7-10.7 10.7c-5.9 0-10.7-4.8-10.7-10.7C1.7 6.5 6.5 1.7 12.5 1.7z"
        fill="#fff"
      />
      <path
        d="M10.8 17.8c.3.3.9.3 1.2 0 .3-.3.3-.9 0-1.2l-3.3-3.3h9.5c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H8.7L12 8.3c.3-.3.3-.9 0-1.2-.2-.2-.4-.2-.6-.2-.2 0-.4.1-.6.2L6 11.8c-.2.2-.2.4-.2.6s.1.4.2.6l4.8 4.8z"
        fill="#fff"
      />
    </svg>
  );
}

export function FavoritesGreyIcon(props: any) {
  const iconStyle = props.small
    ? { height: 18, width: 19 }
    : { height: 24, width: 25 };
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 25 24"
      xmlSpace="preserve"
      style={iconStyle}
    >
      <path
        d="M17.4.5c1.7 0 3.2.7 4.3 1.8 1.1 1.1 1.8 2.6 1.8 4.3 0 4.4-4.1 8-10.1 13.5h0L12 21.3 10.6 20C4.6 14.6.5 11 .5 6.5c0-1.7.7-3.2 1.8-4.3C3.4 1.1 4.9.4 6.6.4c1.9 0 3.8.9 5 2.3.1.3.3.4.4.6.1-.2.2-.3.4-.5 1.2-1.4 3-2.3 5-2.3z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="rgba(0,0,0,0.65)"
        stroke="#fff"
      />
    </svg>
  );
}

export function SwiperBack(props: any) {
  return (
    <svg viewBox="0 0 65 65" style={{ width: 65, ...props.iconStyle }}>
      <circle
        cx={32.5}
        cy={32.5}
        r={32.5}
        fillRule="evenodd"
        clipRule="evenodd"
        fill={props.disabled ? '#E2E2E2' : '#E2E2E2'}
      />
      <path
        d="M34.9 26.4v-4.9c0-.9-.5-1.7-1.3-2.2-.8-.4-1.7-.4-2.4.1L17 29.2c-.7.5-1.1 1.2-1.1 2s.4 1.6 1.1 2L31.2 43c.7.5 1.7.6 2.4.1.8-.4 1.3-1.3 1.3-2.2V36c6.2 0 11.4 4.1 13.4 9.8.5-1.5.8-3.2.8-4.9 0-7.9-6.3-14.5-14.2-14.5z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={props.disabled ? '#ABABAB' : '#ABABAB'}
      />
    </svg>
  );
}

export function SwiperDelete(props: any) {
  return (
    <svg viewBox="0 0 65 65" style={{ width: 65, ...props.iconStyle }}>
      <circle
        cx={32.5}
        cy={32.5}
        r={32.5}
        fillRule="evenodd"
        clipRule="evenodd"
        fill={props.disabled ? '#E0E0E0' : '#FFA0BE'}
      />
      <path
        d="M45.1 19.9c1.2 1.2 1.2 3.1 0 4.3l-8.3 8.3 8.3 8.3c1.2 1.2 1.2 3.1 0 4.3-1.2 1.2-3.1 1.2-4.3 0l-8.3-8.3-8.3 8.3c-1.2 1.2-3.1 1.2-4.3 0-1.2-1.2-1.2-3.1 0-4.3l8.3-8.3-8.3-8.3c-1.2-1.2-1.2-3.1 0-4.3s3.1-1.2 4.3 0l8.3 8.3 8.3-8.3c1.2-1.2 3.1-1.2 4.3 0z"
        fill={props.disabled ? '#A6A6A6' : '#fff'}
      />
    </svg>
  );
}

export function SwiperFavorites(props: any) {
  return (
    <svg viewBox="0 0 65 65" style={{ width: 65, ...props.iconStyle }}>
      <circle
        cx={32.5}
        cy={32.5}
        r={32.5}
        fillRule="evenodd"
        clipRule="evenodd"
        fill={props.disabled ? '#E0E0E0' : '#195A50'}
      />
      <path
        d="M32.7 46l-2.1-1.9C23 37.2 18 32.6 18 27.1c0-4.5 3.6-8.1 8.1-8.1 2.6 0 5 1.2 6.6 3.1 1.6-1.9 4.1-3.1 6.6-3.1 4.5 0 8.1 3.5 8.1 8.1 0 5.5-5 10.1-12.6 17L32.7 46z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={props.disabled ? '#A6A6A6' : '#fff'}
      />
    </svg>
  );
}

export function LeftKey(props: any) {
  return (
    <svg
      viewBox="0 0 27 27"
      style={{ height: 25, width: 25, marginRight: 5, marginLeft: 5 }}
      {...props}
    >
      <path
        d="M3 1h21c1.1 0 2 .9 2 2v21c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
        stroke="#323232"
      />
      <path
        d="M13.8 9.6c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-4.6 4.6c-.4.4-.4 1 0 1.4l4.6 4.6c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-3.9-3.9 3.9-3.9z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#323232"
      />
      <path
        d="M18.5 14.5h-9c-.6 0-1-.4-1-1s.4-1 1-1h9c.6 0 1 .4 1 1s-.4 1-1 1z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#323232"
      />
    </svg>
  );
}

export function KeyB(props: any) {
  return (
    <svg
      viewBox="0 0 27 27"
      style={{ height: 25, width: 25, marginRight: 5, marginLeft: 5 }}
      {...props}
    >
      <path
        d="M3 1h21c1.1 0 2 .9 2 2v21c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
        stroke="#323232"
      />
      <text
        transform="translate(8.5 18.5)"
        fill="#323232"
        fontFamily="Lato"
        fontSize={14}
        fontWeight="bold"
      >
        {'B'}
      </text>
    </svg>
  );
}

export function BackSpaceKey(props: any) {
  return (
    <svg
      viewBox="0 0 82 27"
      style={{ height: 25, marginRight: 5, marginLeft: 5 }}
      {...props}
    >
      <path
        d="M3 1h76c1.1 0 2 .9 2 2v21c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
        stroke="#323232"
      />
      <text
        transform="translate(8 19)"
        fill="#323232"
        fontFamily="Lato"
        fontSize={14}
        fontWeight="bold"
      >
        {'backspace'}
      </text>
    </svg>
  );
}

export function KeyN(props: any) {
  return (
    <svg
      viewBox="0 0 27 27"
      style={{ height: 25, marginRight: 5, marginLeft: 5 }}
      {...props}
    >
      <path
        d="M3 1h21c1.1 0 2 .9 2 2v21c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
        stroke="#323232"
      />
      <text
        transform="translate(8.5 18.5)"
        fill="#323232"
        fontFamily="Lato"
        fontSize={14}
        fontWeight="bold"
      >
        {'N'}
      </text>
    </svg>
  );
}

export function RightKey(props: any) {
  return (
    <svg
      viewBox="0 0 27 27"
      style={{ height: 25, width: 25, marginRight: 5, marginLeft: 5 }}
      {...props}
    >
      <path
        d="M3 1h21c1.1 0 2 .9 2 2v21c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
        stroke="#323232"
      />
      <path
        d="M13.2 17.4c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l4.6-4.6c.4-.4.4-1 0-1.4l-4.6-4.6c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3.9 3.9-3.9 3.9z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#323232"
      />
      <path
        d="M8.5 12.5h9c.6 0 1 .4 1 1s-.4 1-1 1h-9c-.6 0-1-.4-1-1s.4-1 1-1z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#323232"
      />
    </svg>
  );
}

export function FiltersIcon(props: any) {
  const fill = props.dark ? 'black' : '#FFFFFF';
  return (
    <svg viewBox="0 0 20 20" style={{ height: 20, width: 20 }}>
      <path
        d="M0 15.6v2.2h6.7v-2.2H0zM0 2.2v2.2h11.1V2.2H0zM11.1 20v-2.2H20v-2.2h-8.9v-2.2H8.9V20h2.2zM4.4 6.7v2.2H0v2.2h4.4v2.2h2.2V6.7H4.4zM20 11.1V8.9H8.9v2.2H20zm-6.7-4.4h2.2V4.4H20V2.2h-4.4V0h-2.2v6.7h-.1z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={fill}
      />
    </svg>
  );
}

export function MapIcon(props: any) {
  const fill = props.fillColor ? props.fillColor : '#FFFFFF';
  return (
    <svg viewBox="0 0 21 20" style={{ height: 20, width: 21 }}>
      <path
        d="M.7 3.4c-.4.3-.7.8-.7 1.3v13.6c0 .5.3 1 .7 1.3.4.3 1 .3 1.5 0h.1l3.9-2.5c.1-.1.2-.2.2-.3V.4c0-.1-.1-.3-.2-.3s-.4-.1-.5 0l-5 3.3zM8.3.1C8.2 0 8.1 0 8 0c-.2.1-.2.2-.2.4v16.4c0 .1.1.2.2.3l4.5 2.9c.1.1.3.1.4 0 .1-.1.2-.2.2-.3V3.2c0-.1-.1-.2-.2-.3L8.3.1zM19.9.4c-.4-.3-1-.3-1.5 0h-.1l-3.9 2.5c-.1.1-.2.2-.2.3v16.4c0 .1.1.3.2.3.1.1.3.1.4 0l4.9-3.4c.5-.3.8-.8.8-1.3V1.7c.1-.6-.2-1.1-.6-1.3z"
        fill={fill}
      />
    </svg>
  );
}

export function SettingsIcon(props: any) {
  const fill = props.fillColor ? props.fillColor : '#323232';
  return (
    <svg viewBox="0 0 25 26" style={{ height: 26, width: 25 }}>
      <path
        d="M12.2 8.7c-2.4 0-4.3 1.9-4.3 4.3s1.9 4.3 4.3 4.3 4.3-1.9 4.3-4.3-1.9-4.3-4.3-4.3zm9.4 4.3c0 .4 0 .8-.1 1.2l2.6 2.1c.2.2.3.5.1.8l-2.5 4.3c-.2.3-.5.4-.8.3l-3.1-1.2c-.6.5-1.4.9-2.1 1.2l-.4 3.3c-.1.3-.3.5-.6.5h-5c-.3 0-.6-.2-.6-.5l-.5-3.3c-.8-.3-1.5-.7-2.1-1.2l-3.1 1.2c-.3.1-.6 0-.8-.3L.1 17.1c-.2-.3-.1-.6.1-.8l2.6-2.1c-.1-.4-.1-.8-.1-1.2 0-.4 0-.8.1-1.2L.2 9.7c-.2-.2-.3-.5-.1-.8l2.5-4.3c.2-.3.5-.4.8-.3l3.1 1.2c.6-.5 1.4-.9 2.1-1.2L9 1c.1-.3.3-.5.6-.5h5c.3 0 .6.2.6.5l.5 3.3c.8.3 1.5.7 2.1 1.2L21 4.3c.3-.1.6 0 .8.3l2.5 4.3c.2.3.1.6-.1.8l-2.6 2.1c-.1.4 0 .8 0 1.2z"
        fill={fill}
      />
    </svg>
  );
}

export function TrashIcon(props: any) {
  const iconProps = props.light
    ? { fill: '#323232', border: '#FFFFFF' }
    : { fill: '#FFFFFF', border: '#323232' };
  return (
    <svg
      viewBox="0 0 19 22"
      style={{ height: props.small ? '18' : '22', width: 19 }}
    >
      <path
        d="M16.5 5.5h-14v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-14zM18 2.5h-3.6c-.2 0-.4-.1-.6-.3L12.4.5H6.6L5.2 2.2c-.1.2-.3.3-.6.3H1c-.3 0-.5.2-.5.5v2c0 .3.2.5.5.5h17c.3 0 .5-.2.5-.5V3c0-.3-.2-.5-.5-.5z"
        fillOpacity={0.65}
        fill={iconProps.fill}
        stroke={iconProps.border}
      />
      <path
        d="M6 8c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-10c0-.3.2-.5.5-.5zM13 8c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-10c0-.3.2-.5.5-.5zM9.5 8c.3 0 .5.2.5.5v10c0 .3-.2.5-.5.5s-.5-.2-.5-.5v-10c0-.3.2-.5.5-.5z"
        fill={iconProps.border}
      />
    </svg>
  );
}

export function UnFavoriteIcon(props: any) {
  const iconStyle = props.small
    ? { height: 18, width: 19 }
    : { height: 24, width: 25 };
  const strokeColor = props.light ? '#fff' : '#323232';
  return (
    <SvgIcon viewBox="0 0 25 24" style={iconStyle}>
      <path
        d="M12.5 22.4L14 21c8.4-7.7 10.5-10.3 10.5-14.1 0-3.6-2.8-6.4-6.4-6.4-2 0-3.9.9-5.2 2.4l-.4.4-.4-.4C10.8 1.4 8.8.5 6.9.5 3.3.5.5 3.3.5 6.9.5 10.8 2.6 13.3 11 21l1.5 1.4z"
        stroke={strokeColor}
        strokeWidth={1}
        fill="transparent"
      />
    </SvgIcon>
  );
}

export function FullScreenIcon(props: any) {
  return (
    <SvgIcon
      viewBox="0 0 18 18"
      width="18"
      height="18"
      style={{ height: 18, width: 18 }}
    >
      <path
        d="M0 2v4h2V2h4V0H2C.9 0 0 .9 0 2zm2 10H0v4c0 1.1.9 2 2 2h4v-2H2v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V2c0-1.1-.9-2-2-2z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#323232"
      />
    </SvgIcon>
  );
}

export function Share(props: any) {
  const fillColor = props.light ? '#FFFFFF' : '#323232';
  return (
    <svg x="0px" y="0px" viewBox="0 0 17 18" height="18px" width="17px">
      <path
        d="M14.2 12.5c-.8 0-1.5.3-2 .9L5.6 9.7c.1-.5.1-1 0-1.4l6.6-3.6c1 1 2.6 1.1 3.7.3s1.5-2.4.8-3.6C16 .2 14.5-.3 13.2.2c-1.3.5-2 1.9-1.7 3.3L4.9 7.1c-.8-.8-2.1-1.1-3.1-.7C.7 6.8 0 7.9 0 9s.7 2.1 1.8 2.6c1.1.4 2.3.2 3.1-.7l6.6 3.6c-.3 1.1.2 2.4 1.2 3s2.3.6 3.3-.1 1.3-2 1-3.1c-.5-1.1-1.6-1.8-2.8-1.8z"
        fill={fillColor}
      />
    </svg>
  );
}

export function MobilePortraitIcon(props: any) {
  const fillColor = props.light ? '#fff' : '#323232';
  return (
    <svg
      x="0px"
      y="0px"
      width="200px"
      height="200px"
      viewBox="0 0 463.708 463.707"
      xmlSpace="preserve"
      {...props}
    >
      <path
        d="M432.771 351.013v-28.2a2.513 2.513 0 00-2.515-2.524 2.505 2.505 0 00-2.505 2.524v28.2a2.501 2.501 0 002.505 2.506 2.504 2.504 0 002.515-2.506z"
        fill={fillColor}
      />
      <path
        d="M229.569 231.816c-5.279 0-9.562 2.248-9.562 5.01 0 2.773 4.283 5.012 9.562 5.012h198.985c8.606 0 15.625 6.999 15.625 15.615v158.881c0 8.626-7.009 15.635-15.625 15.635H229.262c-5.278 0-9.562-2.228-9.562-4.973 0-2.744 4.284-4.973 9.562-4.973h180.712a2.51 2.51 0 002.516-2.505v-165.25a2.504 2.504 0 00-2.516-2.505H229.262c-5.278 0-9.562-4.284-9.562-9.562V111.329c0-14.133-11.504-25.646-25.656-25.646H35.163c-14.152 0-25.656 11.503-25.656 25.646v326.712c0 14.143 11.504 25.666 25.656 25.666h158.881c9.429 0 17.644-5.136 22.07-12.747 2.658-4.562 7.459-8.96 12.737-8.96h199.693c14.144 0 25.656-11.504 25.656-25.666V257.463c0-14.144-11.503-25.647-25.656-25.647H229.569zm-.307 24.968h168.654c5.278 0 9.562 4.283 9.562 9.562V407.47c0 5.278-4.284 9.562-9.562 9.562H229.262c-5.278 0-9.562-4.284-9.562-9.562V266.347a9.559 9.559 0 019.562-9.563zm-19.594 181.267c0 8.606-6.999 15.615-15.625 15.615H35.163c-8.606 0-15.625-7-15.625-15.615V111.329c0-8.606 7.009-15.616 15.625-15.616h158.881c8.616 0 15.625 7.01 15.625 15.616v326.722z"
        fill={fillColor}
      />
      <path
        d="M197.228 127.394H31.969a2.502 2.502 0 00-2.505 2.505v286.818c0 1.377 1.119 2.524 2.505 2.524h165.259a2.52 2.52 0 002.515-2.524V129.899a2.503 2.503 0 00-2.515-2.505zM185.16 414.211H44.046c-5.278 0-9.562-4.284-9.562-9.562V141.986c0-5.278 4.284-9.562 9.562-9.562H185.16c5.279 0 9.562 4.284 9.562 9.562v262.672c0 5.279-4.274 9.553-9.562 9.553zM100.503 112.122h28.2a2.504 2.504 0 002.515-2.505 2.504 2.504 0 00-2.515-2.506h-28.2a2.504 2.504 0 00-2.515 2.506 2.51 2.51 0 002.515 2.505zM129.047 424.969h-28.888c-5.929 0-10.758 4.82-10.758 10.739v1.74c0 5.919 4.829 10.758 10.758 10.758h28.888c5.929 0 10.758-4.839 10.758-10.758v-1.74c0-5.92-4.829-10.739-10.758-10.739zm5.747 12.479c0 3.155-2.572 5.737-5.747 5.737h-28.888c-3.156 0-5.747-2.582-5.747-5.737v-1.74c0-3.156 2.591-5.737 5.747-5.737h28.888c3.175 0 5.747 2.581 5.747 5.737v1.74zM313.241 131.745c-.058.449 2.122 1.1 4.867 1.454 2.764.334 5.029.239 5.087-.201l.105-.841c3.643-29.251-3.815-58.666-20.99-82.831-9.084-12.775-20.444-23.438-33.717-31.661-44.781-27.808-102.109-22.147-140.55 12.498-2.754 2.467-7.21 2.783-10.136.526l-8.291-6.407c-2.936-2.257-4.924-1.119-4.446 2.543l3.423 26.574a6.672 6.672 0 007.478 5.786l26.574-3.414c3.663-.449 4.265-2.668 1.349-4.915l-7.497-5.805c-2.926-2.257-3.175-6.215-.392-8.645 35.142-30.59 86.77-35.314 127.219-10.231 12.145 7.544 22.511 17.298 30.83 28.984 15.721 22.108 22.538 49.008 19.221 75.773l-.134.813z"
        fill={fillColor}
      />
    </svg>
  );
}

export function ExitIcon(props: any) {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 15 15"
      style={{ height: 15, width: 15 }}
      xmlSpace="preserve"
      {...props}
    >
      <path
        d="M2.9.5l4.6 4.6L12.1.5c.7-.7 1.7-.7 2.4 0s.7 1.7 0 2.4L9.9 7.5l4.6 4.6c.7.7.7 1.7 0 2.4s-1.7.7-2.4 0L7.5 9.9l-4.6 4.6c-.7.7-1.7.7-2.4 0s-.7-1.7 0-2.4l4.6-4.6L.5 2.9C-.2 2.2-.2 1.2.5.5s1.7-.7 2.4 0z"
        fill="#323232"
      />
    </svg>
  );
}

export function ToriiBotHalfWave(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 215 231"
      enableBackground="new 0 0 215 231"
      xmlSpace="preserve"
      {...props}
    >
      <filter
        id="a"
        height="107.6%"
        y="-3.8%"
        width="112.1%"
        x="-6.0%"
        filterUnits="objectBoundingBox"
      >
        <feOffset dy={2} in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={5}
        />
        <feColorMatrix
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          in="shadowBlurOuter1"
          result="shadowMatrixOuter1"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixOuter1" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <g transform="translate(23 -191) translate(-6 208)" filter="url(#a)">
        <g transform="translate(.168 .545) rotate(-15 141.266 17.84) translate(0 .352)">
          <linearGradient
            id="b"
            gradientUnits="userSpaceOnUse"
            x1={-311.5992}
            y1={410.0668}
            x2={-311.5992}
            y2={409.0668}
            gradientTransform="matrix(-1.5529 15.4548 5.7956 4.1411 -2786.45 3138.226)"
          >
            <stop offset={0} stopColor="#e8eef5" />
            <stop offset={1} stopColor="#bec7d8" />
          </linearGradient>
          <path fill="url(#b)" d="M73.5 12.6L74 28.6 68 28.6 68.5 12.6z" />
          <radialGradient
            id="c"
            cx={-313.3923}
            cy={367.7571}
            r={0.6985}
            gradientTransform="scale(16 -16) rotate(-15 -1553.171 -1023.464)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopColor="#cfe7e2" />
            <stop offset={1} stopColor="#195a50" />
          </radialGradient>
          <circle fill="url(#c)" cx={71} cy={8.4} r={8} />
          <linearGradient
            id="d"
            gradientUnits="userSpaceOnUse"
            x1={-315.3223}
            y1={379.0576}
            x2={-315.3223}
            y2={378.0576}
            gradientTransform="matrix(13.523 9.0587 3.6235 -33.8074 2897.59 15724.003)"
          >
            <stop offset={0} stopColor="#e8eef5" />
            <stop offset={1} stopColor="#bec7d8" />
          </linearGradient>
          <path
            fill="url(#d)"
            d="M3.6 55.1L14 52.6v35L3.6 85.2c-1-.2-1.9-1-2.2-2-.9-3-1.4-7.3-1.4-13s.5-10.1 1.4-13c.3-1.1 1.1-1.9 2.2-2.1z"
          />
          <linearGradient
            id="e"
            gradientUnits="userSpaceOnUse"
            x1={-336.2123}
            y1={391.4565}
            x2={-336.2123}
            y2={392.4565}
            gradientTransform="matrix(-13.523 -9.0587 -3.6235 33.8074 -2993.158 -16227.117)"
          >
            <stop offset={0} stopColor="#e8eef5" />
            <stop offset={1} stopColor="#bec7d8" />
          </linearGradient>
          <path
            fill="url(#e)"
            d="M138.4 85.2L128 87.6v-35l10.4 2.4c1 .2 1.9 1 2.2 2 .9 3 1.4 7.3 1.4 13s-.5 10.1-1.4 13c-.3 1.2-1.1 2-2.2 2.2z"
          />
          <path
            fill="#FFF"
            d="M35 29.9c10.6-.8 22.9-1.2 37-1.2v84c-13.7 0-25.8-.5-36.3-1.6-12.4-1.3-21.9-11.4-22.4-23.8L12 55.9c-.6-13.5 9.6-25 23-26z"
          />
          <path
            fill="#E9ECF4"
            d="M107 29.9c-10.4-.8-22.4-1.2-36-1.2v84c13.3 0 25.1-.5 35.3-1.6a24.95 24.95 0 0022.4-23.9l1.3-31.4c.6-13.4-9.6-24.9-23-25.9z"
          />
          <path
            fill="#21324A"
            d="M35.1 38.1c12-1.6 23.9-2.5 35.9-2.5 11.9 0 23.9.8 35.9 2.5a19.99 19.99 0 0117.3 20.8l-1.5 29.7c-.3 6.2-4.4 11.5-10.2 13.5-9.1 3-22.9 4.6-41.4 4.6s-32.3-1.5-41.4-4.6c-5.9-2-9.9-7.3-10.2-13.5L18 58.9c-.6-10.4 6.9-19.4 17.1-20.8z"
          />
          <path
            fill="#FFF"
            d="M61.4 81.6H81c0 5-4.1 9.1-9.1 9.1h-1.4c-5 0-9.1-4.1-9.1-9.1z"
          />
          <circle fill="#195a50" cx={96.9} cy={70.7} r={7} />
          <circle fill="#195a50" cx={45} cy={70.7} r={7} />
        </g>
        <g transform="translate(.168 .545) rotate(-15 141.266 17.84) translate(17 115)">
          <path
            fill="#E9ECF4"
            d="M38.1.6c11.2 0 20.3.4 27.3 1.3s12.5 6.5 13.1 13.5l2.6 27.9-43-11.5V.6z"
            transform="translate(13.274 4.419)"
          />
          <g transform="translate(13.274 4.419)">
            <linearGradient
              id="f"
              gradientUnits="userSpaceOnUse"
              x1={-351.4158}
              y1={259.5504}
              x2={-351.519}
              y2={259.029}
              gradientTransform="matrix(41.5348 11.0374 11.1292 -41.192 11766.4 14594.847)"
            >
              <stop offset={0} stopColor="#fff" stopOpacity={0} />
              <stop offset={1} stopOpacity={0.05} />
            </linearGradient>
            <path
              fill="url(#f)"
              d="M38.1.6c11.2 0 20.3.4 27.3 1.3s12.5 6.5 13.1 13.5l2.6 27.9-43-11.5V.6z"
            />
          </g>
          <path
            fill="#FFF"
            d="M14 1.8C20.6 1 29.2.6 39.7.6v31.6L.3 21.6l.6-6.2C1.5 8.3 7 2.6 14 1.8z"
            transform="translate(13.274 4.419)"
          />
          <g transform="translate(13.274 4.419)">
            <linearGradient
              id="g"
              gradientUnits="userSpaceOnUse"
              x1={-350.4307}
              y1={256.9973}
              x2={-350.5338}
              y2={256.6575}
              gradientTransform="matrix(38.0904 8.1706 10.2063 -30.4931 10746.156 10720.691)"
            >
              <stop offset={0} stopColor="#fff" stopOpacity={0} />
              <stop offset={1} stopOpacity={0.05} />
            </linearGradient>
            <path
              fill="url(#g)"
              d="M14 1.8C20.6 1 29.2.6 39.7.6v31.6L.3 21.6l.6-6.2C1.5 8.3 7 2.6 14 1.8z"
            />
          </g>
          <radialGradient
            id="h"
            cx={-298.5738}
            cy={285.9605}
            r={1}
            gradientTransform="matrix(-10.6369 6.6603 39.6976 1.7846 -14474.334 1483.263)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset={0} stopOpacity={0.25} />
            <stop offset={1} stopColor="#fff" stopOpacity={0} />
          </radialGradient>
          <path
            fill="url(#h)"
            d="M53.5 11.9c17.7 0 30.9-1.1 30.9-3.3S72.3 5 53.3 5 22.1 6.2 22.1 8.4s13.7 3.5 31.4 3.5z"
          />
          <linearGradient
            id="i"
            gradientUnits="userSpaceOnUse"
            x1={-332.2874}
            y1={256.9014}
            x2={-333.2874}
            y2={255.9014}
            gradientTransform="scale(19.553 -19.553) rotate(-15 -1138.97 -1156.27)"
          >
            <stop offset={0} stopColor="#e8eef5" />
            <stop offset={1} stopColor="#bec7d8" />
          </linearGradient>
          <circle fill="url(#i)" cx={107.2} cy={10.5} r={9.8} />
          <linearGradient
            id="j"
            gradientUnits="userSpaceOnUse"
            x1={-332.2874}
            y1={256.9014}
            x2={-333.2874}
            y2={255.9014}
            gradientTransform="scale(19.553 -19.553) rotate(-15 -1143.182 -1137.664)"
          >
            <stop offset={0} stopColor="#e8eef5" />
            <stop offset={1} stopColor="#bec7d8" />
          </linearGradient>
          <circle fill="url(#j)" cx={10.2} cy={19.4} r={9.8} />
        </g>
      </g>
      <path
        fill="#FF7350"
        d="M124.5 179.2c3.6.7 7.2.1 10.7-1.6.3-.1.5-.4.7-.7.1-.3.2-.7.1-1l-.3-1.1c-.2-.8-.6-1.6-1.2-2.2-.5-.6-1.2-1.2-2-1.5l-11.3-5.2c-.9-.4-2-.5-2.9-.2s-1.8.9-2.4 1.7l-2.2 3.3c-.2.3-.3.6-.2.9 0 .3.1.6.3.9 2.9 3.5 6.5 6 10.7 6.7"
      />
      <path
        fill="#FFA0BE"
        d="M119 183.1c-1.5-3-3.9-5.6-6.9-7.5-.3-.2-.7-.3-1.1-.2-.4.1-.7.3-.9.6l-1.2 1.8c-.5.7-.8 1.5-.9 2.3-.1.8.1 2.2.3 3"
      />
      <path
        fill="#463264"
        d="M138 183.1l-.4-1.4c-.1-.2-.1-.4-.3-.5-.1-.2-.3-.3-.4-.4-.2-.1-.3-.2-.5-.2h-.6c-1.9.6-3.7 1.3-5.2 2.4"
      />
    </svg>
  );
}

export function LeftNavIcon(props: any) {
  return props.small ? (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 25 25"
      style={{ height: 25, width: 25 }}
      xmlSpace="preserve"
      {...props}
    >
      <circle
        cx={12.5}
        cy={12.5}
        r={12.5}
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
      />
      <path
        fill="none"
        stroke="#323232"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14.2 18.8L8 12.5 14.2 6.2"
      />
    </svg>
  ) : (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 65 65"
      style={{ height: 65, width: 65 }}
      xmlSpace="preserve"
      {...props}
    >
      <circle
        cx={32.5}
        cy={32.5}
        r={32.5}
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#323232"
        d="M39.6 42.1L36.5 45 23 32.5 36.5 20 39.6 22.9 29.3 32.5z"
      />
    </svg>
  );
}

export function RightNavIcon(props: any) {
  return props.small ? (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 25 25"
      style={{ height: 25, width: 25 }}
      xmlSpace="preserve"
      {...props}
    >
      <circle
        cx={12.5}
        cy={12.5}
        r={12.5}
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
      />
      <path
        fill="none"
        stroke="#323232"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 6.2L16.2 12.5 10 18.8"
      />
    </svg>
  ) : (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 65 65"
      style={{ height: 65, width: 65 }}
      xmlSpace="preserve"
      {...props}
    >
      <circle
        cx={32.5}
        cy={32.5}
        r={32.5}
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#323232"
        d="M25 22.9L28.1 20 41.6 32.5 28.1 45 25 42.1 35.3 32.5z"
      />
    </svg>
  );
}

export function ThreeDimensionIcon(props: any) {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 23 20"
      xmlSpace="preserve"
      style={{ height: 20, width: 22 }}
      {...props}
    >
      <g fill="#463264">
        <path
          d="M6.7 6V3v-.1-.1L1 5.9v6.7L6.2 10c.3-.1.5-.5.5-.8V7.9c1.7.8 2.6 2 2.6 3.1 0 1.4-1.5 2.8-4 3.7l.6 1.7c3.3-1.1 5.2-3.1 5.2-5.3 0-2.2-1.6-4-4.4-5.1z"
          transform="translate(10.5 .5)"
        />
        <path
          d="M-.6 13l-1.2 1.2 1.1 1.1c-4.2-.3-7.5-2.2-7.5-4.3 0-1.1 1-2.3 2.6-3.1v1.3c0 .3.2.6.5.8l5.2 2.6V5.9l-5.7-3.1V6C-8.4 7.1-10 9-10 11c0 3.2 4.1 5.8 9.4 6.1l-1.1 1.2 1.3 1.2 2.5-2.6c.3-.3.3-.9 0-1.2L-.6 13zM6 2.1L.9-.4C.7-.5.4-.5.1-.4L-5 2.1l5.4 3 5.6-3z"
          transform="translate(10.5 .5)"
        />
      </g>
    </svg>
  );
}

export function StreetViewIcon(props: any) {
  return (
    <svg
      x="0px"
      y="0px"
      viewBox="0 0 17 20"
      xmlSpace="preserve"
      style={{ height: 20, width: 22 }}
      {...props}
    >
      <path
        d="M8.3 4.7c1.3 0 2.3-1.1 2.3-2.3S9.6 0 8.3 0C7 0 6 1.1 6 2.3s1 2.4 2.3 2.4zM14.1 15.8c-.4-.1-.9-.2-1.4-.3-.3 0-.6.2-.7.5 0 .3.2.6.5.7.4 0 .7.1 1 .2 1.4.3 1.9.6 2.1.7-.2.2-.8.5-2.1.7-1.4.3-3.2.4-5.1.4s-3.7-.2-5.1-.4c-1.4-.3-1.9-.6-2.1-.7.2-.2.8-.5 2.1-.7.2 0 .5-.1.8-.1.3 0 .5-.3.5-.7 0-.3-.3-.6-.7-.5-.4.1-.8.1-1.2.2-1.9.4-2.8 1-2.8 1.8s.9 1.4 2.8 1.8c1.6.4 3.6.6 5.8.6s4.1-.2 5.7-.5c1.9-.4 2.8-1 2.8-1.8-.1-.8-1-1.4-2.9-1.9z"
        fill="#463264"
      />
      <path
        d="M5.8 11.9V16c0 1 .8 1.8 1.8 1.8h1.6c1 0 1.8-.8 1.8-1.8v-4.1c.6-.3 1-.9 1-1.6V7.6c0-1-.8-1.8-1.8-1.8H6.6c-1 0-1.8.8-1.8 1.8v2.7c0 .7.4 1.3 1 1.6z"
        fill="#463264"
      />
    </svg>
  );
}

export function CheckCircleIcon(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={{ height: 48, width: 48 }}
      {...props}
    >
      <path
        d="M32 56c13.3 0 24-10.7 24-24S45.3 8 32 8 8 18.7 8 32s10.7 24 24 24z"
        opacity={0.2}
        fill="#195a50"
      />
      <path
        d="M43 26L28.3 40 21 33"
        fill="none"
        stroke="#195a50"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32 56c13.3 0 24-10.7 24-24S45.3 8 32 8 8 18.7 8 32s10.7 24 24 24z"
        fill="none"
        stroke="#195a50"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SaveSearchIcon(props: any) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.875 18.75a7.875 7.875 0 100-15.75 7.875 7.875 0 000 15.75zM16.443 16.444L20.999 21"
        stroke="#323232"
        strokeWidth={2.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.555 8.727a2.267 2.267 0 00-2.545-.594 2.31 2.31 0 00-.77.505l-.365.365-.286-.286c-.888-.889-2.334-.964-3.22-.163a2.284 2.284 0 00-.09 3.316l3.165 3.165a.61.61 0 00.862 0l3.086-3.086c.89-.89.962-2.335.163-3.222z"
        fill="#323232"
      />
    </svg>
  );
}

export function SaveSearchGreyIcon(props: any) {
  return (
    <svg
      width={24}
      height={24}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.875 18.75a7.875 7.875 0 100-15.75 7.875 7.875 0 000 15.75zM16.443 16.444L20.999 21"
        stroke="#979797"
        strokeWidth={2.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.555 8.727a2.267 2.267 0 00-2.545-.594 2.31 2.31 0 00-.77.505l-.365.365-.286-.286c-.888-.889-2.334-.964-3.22-.163a2.284 2.284 0 00-.09 3.316l3.165 3.165a.61.61 0 00.862 0l3.086-3.086c.89-.89.962-2.335.163-3.222z"
        fill="#979797"
      />
    </svg>
  );
}

export function SaveSearchWhiteIcon(props: any) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.4435 16.4435C14.9666 17.9203 12.9636 18.75 10.875 18.75C8.78642 18.75 6.78338 17.9203 5.30653 16.4435C3.82969 14.9666 3 12.9636 3 10.875C3 8.78642 3.82969 6.78338 5.30653 5.30653C6.78338 3.82969 8.78642 3 10.875 3C12.9636 3 14.9666 3.82969 16.4435 5.30653C17.9203 6.78338 18.75 8.78642 18.75 10.875C18.75 12.9636 17.9203 14.9666 16.4435 16.4435ZM16.4435 16.4435L20.999 21"
        stroke="white"
        strokeWidth={2.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.555 8.727C14.244 8.37746 13.8324 8.13272 13.3767 8.02637C12.9211 7.92002 12.4437 7.95727 12.01 8.133C11.7221 8.24795 11.4602 8.4197 11.24 8.638L10.875 9.003L10.589 8.717C9.70101 7.828 8.25501 7.753 7.36901 8.554C7.13785 8.76125 6.95137 9.01344 6.82096 9.29518C6.69055 9.57692 6.61894 9.88229 6.61052 10.1926C6.6021 10.503 6.65703 10.8118 6.77197 11.1002C6.88691 11.3886 7.05944 11.6505 7.27901 11.87L10.444 15.035C10.5584 15.1492 10.7134 15.2133 10.875 15.2133C11.0366 15.2133 11.1916 15.1492 11.306 15.035L14.392 11.949C15.282 11.059 15.354 9.614 14.555 8.727Z"
        fill="white"
      />
    </svg>
  );
}

export function NoListingIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" {...props}>
      <path
        d="M29 50c11.6 0 21-9.4 21-21S40.6 8 29 8 8 17.4 8 29s9.4 21 21 21zM43.8 43.8L56 56"
        fill="none"
        stroke="#323232"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.5 27v10.1c0 .7-.6 1.3-1.3 1.3H22.1c-.7 0-1.3-.6-1.3-1.3V27l5-5 1.6-1.6c.9-.9 2.5-.9 3.4 0l1.6 1.6 5.1 5z"
        fill="#e2e2e2"
      />
      <path
        d="M27.9 31h2.5c.8 0 1.4.6 1.4 1.4v5.9h-5.3v-5.9c0-.8.6-1.4 1.4-1.4z"
        fill="#e2e2e2"
      />
      <path
        d="M37.5 27v10.1c0 .7-.6 1.3-1.3 1.3h-.6c.1-.2.1-.4.1-.6V27.7L29.2 21c-.5-.5-1.1-.7-1.7-.7.9-.9 2.4-.9 3.4 0l6.6 6.7zM31.8 32.4v5.9h-1.7v-5.9c0-.8-.6-1.4-1.4-1.4h1.7c.8 0 1.4.6 1.4 1.4z"
        fill="#ababab"
      />
      <path
        d="M39.6 28.2l-8.3-8.3c-1.2-1.2-3.2-1.2-4.4 0l-8.3 8.3c-.3.3-.3.7 0 .9.3.3.7.3.9 0l.5-.5v8.5c0 1.1.9 1.9 1.9 1.9H36c1.1 0 1.9-.9 1.9-1.9v-8.5l.5.5c.1.1.3.2.5.2s.3-.1.5-.2c.5-.2.5-.6.2-.9zm-12.4 9.5v-5.3c0-.4.3-.7.8-.7h2.5c.4 0 .8.3.8.7v5.3h-4.1zm9.6-.6c0 .3-.3.6-.6.6h-3.8v-5.3c0-1.1-.9-2.1-2.1-2.1h-2.5c-1.1 0-2.1.9-2.1 2.1v5.3h-3.8c-.3 0-.6-.3-.6-.6v-9.8l6.4-6.4c.7-.7 1.8-.7 2.5 0l6.4 6.4v9.8z"
        fill="#323232"
      />
    </svg>
  );
}

export function EmptySaveSearchIcon(props: any) {
  return (
    <svg
      id="b21613c9-2bf0-4d37-bef0-3b193d34fc5d"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="647.63626"
      height="632.17383"
      viewBox="0 0 647.63626 632.17383"
      {...props}
    >
      <path
        d="M687.3279,276.08691H512.81813a15.01828,15.01828,0,0,0-15,15v387.85l-2,.61005-42.81006,13.11a8.00676,8.00676,0,0,1-9.98974-5.31L315.678,271.39691a8.00313,8.00313,0,0,1,5.31006-9.99l65.97022-20.2,191.25-58.54,65.96972-20.2a7.98927,7.98927,0,0,1,9.99024,5.3l32.5498,106.32Z"
        transform="translate(-276.18187 -133.91309)"
        fill="#f2f2f2"
      />
      <path
        d="M725.408,274.08691l-39.23-128.14a16.99368,16.99368,0,0,0-21.23-11.28l-92.75,28.39L380.95827,221.60693l-92.75,28.4a17.0152,17.0152,0,0,0-11.28028,21.23l134.08008,437.93a17.02661,17.02661,0,0,0,16.26026,12.03,16.78926,16.78926,0,0,0,4.96972-.75l63.58008-19.46,2-.62v-2.09l-2,.61-64.16992,19.65a15.01489,15.01489,0,0,1-18.73-9.95l-134.06983-437.94a14.97935,14.97935,0,0,1,9.94971-18.73l92.75-28.4,191.24024-58.54,92.75-28.4a15.15551,15.15551,0,0,1,4.40966-.66,15.01461,15.01461,0,0,1,14.32032,10.61l39.0498,127.56.62012,2h2.08008Z"
        transform="translate(-276.18187 -133.91309)"
        fill="#3f3d56"
      />
      <path
        d="M398.86279,261.73389a9.0157,9.0157,0,0,1-8.61133-6.3667l-12.88037-42.07178a8.99884,8.99884,0,0,1,5.9712-11.24023l175.939-53.86377a9.00867,9.00867,0,0,1,11.24072,5.9707l12.88037,42.07227a9.01029,9.01029,0,0,1-5.9707,11.24072L401.49219,261.33887A8.976,8.976,0,0,1,398.86279,261.73389Z"
        transform="translate(-276.18187 -133.91309)"
        fill="#bdbdbd"
      />
      <circle cx="190.15351" cy="24.95465" r="20" fill="#bdbdbd" />
      <circle cx="190.15351" cy="24.95465" r="12.66462" fill="#fff" />
      <path
        d="M878.81836,716.08691h-338a8.50981,8.50981,0,0,1-8.5-8.5v-405a8.50951,8.50951,0,0,1,8.5-8.5h338a8.50982,8.50982,0,0,1,8.5,8.5v405A8.51013,8.51013,0,0,1,878.81836,716.08691Z"
        transform="translate(-276.18187 -133.91309)"
        fill="#e6e6e6"
      />
      <path
        d="M723.31813,274.08691h-210.5a17.02411,17.02411,0,0,0-17,17v407.8l2-.61v-407.19a15.01828,15.01828,0,0,1,15-15H723.93825Zm183.5,0h-394a17.02411,17.02411,0,0,0-17,17v458a17.0241,17.0241,0,0,0,17,17h394a17.0241,17.0241,0,0,0,17-17v-458A17.02411,17.02411,0,0,0,906.81813,274.08691Zm15,475a15.01828,15.01828,0,0,1-15,15h-394a15.01828,15.01828,0,0,1-15-15v-458a15.01828,15.01828,0,0,1,15-15h394a15.01828,15.01828,0,0,1,15,15Z"
        transform="translate(-276.18187 -133.91309)"
        fill="#3f3d56"
      />
      <path
        d="M801.81836,318.08691h-184a9.01015,9.01015,0,0,1-9-9v-44a9.01016,9.01016,0,0,1,9-9h184a9.01016,9.01016,0,0,1,9,9v44A9.01015,9.01015,0,0,1,801.81836,318.08691Z"
        transform="translate(-276.18187 -133.91309)"
        fill="#bdbdbd"
      />
      <circle cx="433.63626" cy="105.17383" r="20" fill="#bdbdbd" />
      <circle cx="433.63626" cy="105.17383" r="12.18187" fill="#fff" />
    </svg>
  );
}

export function IncrementButtonIcon(props: any) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12zM11 16h10M16 11v10"
        stroke="#323232"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function DecrementButtonIcon(props: any) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12zM11 16h10"
        stroke="#323232"
        strokeOpacity={0.5}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ByeBye(props: any) {
  return (
    <svg
      width={208}
      height={209}
      viewBox="0 0 208 209"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        y={0.5}
        width={208}
        height={208}
        rx={104}
        fill="#463264"
        fillOpacity={0.3}
      />
      <path
        d="M118.602 87.982a9.533 9.533 0 1116.513-9.533l9.533 16.512a38.146 38.146 0 013.815 28.94 38.137 38.137 0 01-31.86 27.942 38.139 38.139 0 01-38.004-18.749l-18.113-31.373a9.532 9.532 0 0116.512-9.533l-9.534-16.512a9.532 9.532 0 1116.513-9.534l3.813 6.605a9.534 9.534 0 0116.512-9.533l14.3 24.768z"
        fill="#fff"
      />
      <path
        d="M100.184 94.213L87.79 72.747a9.533 9.533 0 0116.513-9.533l19.066 33.024"
        stroke="#463264"
        strokeWidth={7.62667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M85.578 107.049L67.465 75.676a9.534 9.534 0 1116.512-9.534l16.207 28.071"
        fill="#fff"
      />
      <path
        d="M85.578 107.049L67.465 75.676a9.534 9.534 0 1116.512-9.534l16.207 28.071"
        stroke="#463264"
        strokeWidth={7.62667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M116.39 122.284a19.068 19.068 0 016.979-26.046l-4.767-8.256a9.533 9.533 0 1116.513-9.533l9.533 16.512a38.146 38.146 0 013.815 28.94 38.137 38.137 0 01-31.86 27.942 38.139 38.139 0 01-38.004-18.749l-18.113-31.373a9.532 9.532 0 0116.512-9.533l8.58 14.861"
        fill="#fff"
      />
      <path
        d="M116.39 122.284a19.068 19.068 0 016.979-26.046l-4.767-8.256a9.533 9.533 0 1116.513-9.533l9.533 16.512a38.146 38.146 0 013.815 28.94 38.137 38.137 0 01-31.86 27.942 38.139 38.139 0 01-38.004-18.749l-18.113-31.373a9.532 9.532 0 0116.512-9.533l8.58 14.861M81.642 157.888a53.171 53.171 0 01-15.775-17.166M126.88 58.263a24.776 24.776 0 0121.463 12.396"
        stroke="#463264"
        strokeWidth={7.62667}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SadFaceIcon(props: any) {
  return (
    <svg
      width={150}
      height={150}
      viewBox="0 0 150 150"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={150} height={150} rx={75} fill="#463264" fillOpacity={0.3} />
      <path
        d="M75 105c16.569 0 30-13.431 30-30 0-16.569-13.431-30-30-30-16.569 0-30 13.431-30 30 0 16.569 13.431 30 30 30z"
        fill="#fff"
      />
      <path
        d="M75 105c16.569 0 30-13.431 30-30 0-16.569-13.431-30-30-30-16.569 0-30 13.431-30 30 0 16.569 13.431 30 30 30z"
        stroke="#463264"
        strokeWidth={5}
        strokeMiterlimit={10}
      />
      <path
        d="M87.993 90a15.008 15.008 0 00-25.986 0"
        stroke="#463264"
        strokeWidth={5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.75 72.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5zM86.25 72.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
        fill="#463264"
      />
      <path
        d="M63.75 72.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5zM86.25 72.5a3.75 3.75 0 100-7.5 3.75 3.75 0 000 7.5z"
        fill="#463264"
      />
    </svg>
  );
}

export function BackwardsLeftIcon(props: any) {
  return (
    <svg
      width={34}
      height={37}
      viewBox="0 0 34 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#prefix__filter0_d)">
        <path
          opacity={0.2}
          d="M17 28c6.627 0 12-5.373 12-12S23.627 4 17 4 5 9.373 5 16s5.373 12 12 12z"
          fill="#fff"
        />
        <path
          d="M17 28c6.627 0 12-5.373 12-12S23.627 4 17 4 5 9.373 5 16s5.373 12 12 12z"
          stroke="#fff"
          strokeWidth={2}
          strokeMiterlimit={10}
        />
        <path
          d="M19 11.5L14 16l5 4.5"
          stroke="#fff"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="prefix__filter0_d"
          x={-3}
          y={0}
          width={40}
          height={40}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export function ForwardRightIcon(props: any) {
  return (
    <svg
      width={34}
      height={37}
      viewBox="0 0 34 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#prefix__filter0_d)">
        <path
          opacity={0.2}
          d="M17 28c6.627 0 12-5.373 12-12S23.627 4 17 4 5 9.373 5 16s5.373 12 12 12z"
          fill="#fff"
        />
        <path
          d="M17 28c6.627 0 12-5.373 12-12S23.627 4 17 4 5 9.373 5 16s5.373 12 12 12z"
          stroke="#fff"
          strokeWidth={2}
          strokeMiterlimit={10}
        />
        <path
          d="M15.5 11.5l5 4.5-5 4.5"
          stroke="#fff"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <filter
          id="prefix__filter0_d"
          x={-3}
          y={0}
          width={40}
          height={40}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export function ExtensionHandshakeIcon(...props: any) {
  const iconProps = props[0];
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...iconProps}>
      <path
        d="M15.045 7.611l-1.545.773-2-3.83 1.56-.78a.5.5 0 01.667.215l1.537 2.944a.501.501 0 01-.22.678v0zM2.5 8.317L.955 7.545a.5.5 0 01-.22-.68l1.538-2.943a.5.5 0 01.666-.215l1.561.78-2 3.83zM13.5 8.384l-1 1.17-2.3 2.3a.501.501 0 01-.475.131l-3.622-.905a.5.5 0 01-.187-.092L2.5 8.317"
        stroke="#323232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 9.554l-2.75-2-.8.6a2 2 0 01-2.4 0L6.21 7.9a.5.5 0 01-.053-.754L8.603 4.7a.5.5 0 01.354-.146h2.542"
        stroke="#323232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.536 4.487l3.208-.935a.5.5 0 01.346.024l2.16.978M7 13.304l-1.884-.471a.5.5 0 01-.206-.108L3.5 11.5"
        stroke="#323232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ExtensionSignoutIcon(...props: any) {
  const iconProps = props[0];
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...iconProps}>
      <path
        d="M10.876 5.375L13.5 8l-2.624 2.625M6.5 8h6.998M6.5 13.5H3a.5.5 0 01-.5-.5V3a.5.5 0 01.5-.5h3.5"
        stroke="#323232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ExtensionUserIcon(...props: any) {
  const iconProps = props[0];
  return (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...iconProps}>
      <path
        d="M8 10a4 4 0 100-8 4 4 0 000 8zM1.937 13.5a7.003 7.003 0 0112.126 0"
        stroke="#323232"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ExtensionSettingsIcon(...props: any) {
  const iconProps = props[0];
  return (
    <svg width={14} height={14} viewBox="0 0 14 14" fill="none" {...iconProps}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.002 8c0 .227-.02.44-.047.653l1.407 1.1c.127.1.16.28.08.427l-1.334 2.307c-.08.146-.253.207-.406.146l-1.66-.666c-.347.26-.72.486-1.127.653l-.253 1.767c-.02.16-.16.28-.327.28H6.67a.325.325 0 01-.327-.28l-.253-1.767a4.87 4.87 0 01-1.127-.653l-1.66.666a.335.335 0 01-.407-.146L1.562 10.18a.336.336 0 01.08-.426l1.407-1.1A5.289 5.289 0 013.002 8c0-.22.02-.44.047-.653l-1.407-1.1a.329.329 0 01-.08-.427l1.333-2.307c.08-.146.254-.206.407-.146l1.66.667c.347-.26.72-.487 1.127-.654l.253-1.766c.02-.16.16-.28.327-.28h2.666c.167 0 .307.12.327.28l.253 1.766c.407.167.78.387 1.127.654l1.66-.667a.335.335 0 01.406.147l1.334 2.306a.336.336 0 01-.08.427l-1.407 1.1c.027.213.047.426.047.653zM5.669 8a2.336 2.336 0 002.333 2.334A2.336 2.336 0 0010.335 8a2.336 2.336 0 00-2.333-2.333A2.336 2.336 0 005.669 8z"
        fill="#323232"
      />
    </svg>
  );
}

export function ExtensionLogoIcon(...props: any) {
  const iconProps = props[0];
  return (
    <svg
      width={31}
      height={31}
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...iconProps}
    >
      <path
        d="M17.093 20.812v-3.188a.531.531 0 00-.53-.53h-2.126a.531.531 0 00-.531.53v3.188a.531.531 0 01-.531.531h-3.187a.531.531 0 01-.532-.53v-6.14a.531.531 0 01.174-.394l5.312-4.83a.531.531 0 01.715 0l5.313 4.83a.532.532 0 01.174.393v6.14a.53.53 0 01-.532.532h-3.188a.532.532 0 01-.53-.532z"
        fill="#5E44FF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 1l1.49 3.096c.526.068 1.041.171 1.543.308L21.05 2.1l.233 3.458c.29.168.57.349.843.541l4.21-1.357-1.52 4.013c.191.265.372.537.54.818l3.612.176-2.378 2.696c.14.512.247 1.039.316 1.577l3.559 1.658-3.636 1.806c-.045.26-.1.518-.162.772l2.457 2.801-3.65.168c-.228.398-.48.78-.753 1.146l1.339 3.585-3.715-1.216c-.256.19-.52.37-.792.538l-.27 4.212-3.089-2.81c-.441.107-.892.187-1.352.24L15.55 29.71l-1.391-2.787a11.441 11.441 0 01-1.652-.316l-2.8 2.578-.276-3.915a11.536 11.536 0 01-.806-.55l-6.817 4.434 4.514-6.724c-.285-.376-.546-.77-.784-1.18l-3.63-.28 2.447-2.623c-.1-.39-.179-.789-.237-1.194l-3.342-1.65 3.329-1.56c.049-.362.115-.72.197-1.07L1.457 9.396l4.327-.052c.12-.188.245-.373.374-.554l-1.375-4.04 3.974 1.433c.337-.245.687-.471 1.05-.678l.31-3.762 2.721 2.566c.384-.091.775-.163 1.173-.214L15.5 1z"
        fill="#fff"
      />
      <path
        d="M30.749 15.094l-3.759-1.88 2.754-3.174a.454.454 0 00-.311-.75L25.24 8.99l1.329-3.986a.454.454 0 00-.575-.575L22.01 5.76l-.298-4.193a.454.454 0 00-.75-.31L17.785 4.01 15.906.25a.454.454 0 00-.812 0l-1.88 3.759-3.174-2.754a.454.454 0 00-.75.311L9.05 4.94c-.018.25-.06-.417.49.322s.532-1.897.55-2.148l.04-.575 2.931 2.541a.454.454 0 00.704-.14L15.5 1.47l1.735 3.47a.454.454 0 00.704.14l2.93-2.541.275 3.87a.454.454 0 00.597.398l3.68-1.227-1.227 3.68a.454.454 0 00.399.597l3.87.275-2.542 2.93a.454.454 0 00.14.704l3.47 1.735-3.47 1.735a.454.454 0 00-.14.704l2.541 2.93-3.87.275a.454.454 0 00-.398.597l1.227 3.68-3.68-1.227a.455.455 0 00-.597.399l-.275 3.87-2.93-2.542a.454.454 0 00-.704.14L15.5 29.53l-1.735-3.47a.454.454 0 00-.704-.14l-2.93 2.541-.275-3.87a.454.454 0 00-.705-.345l-7.04 4.69 4.644-7.091a.454.454 0 00-.348-.702l-3.87-.275 2.542-2.93a.454.454 0 00-.14-.704L1.47 15.5l3.47-1.735a.454.454 0 00.14-.704l-2.541-2.93 3.87-.275a.454.454 0 00.398-.597L5.579 5.58l3.68 1.227a.454.454 0 00.597-.399l.105-1.482a.454.454 0 00-.906-.064l-.064.898L5.005 4.43a.454.454 0 00-.575.575L5.76 8.99l-4.192.298a.454.454 0 00-.31.75l2.753 3.175-3.759 1.88a.454.454 0 000 .812l3.759 1.88-2.754 3.174a.454.454 0 00.311.75l4.004.285-5.436 8.302a.454.454 0 00.631.627l8.24-5.488.283 3.997a.454.454 0 00.75.31l3.175-2.753 1.88 3.759a.454.454 0 00.812 0l1.88-3.759 3.174 2.754a.454.454 0 00.75-.311l.299-4.192 3.986 1.329a.454.454 0 00.575-.575L25.24 22.01l4.192-.298a.454.454 0 00.31-.75l-2.753-3.175 3.759-1.88a.454.454 0 000-.812z"
        fill="#323232"
      />
      <g clipPath="url(#prefix__clip0)">
        <path
          d="M21.36 13.593v7.09a.879.879 0 01-.88.879h-9.96a.879.879 0 01-.88-.879v-7.09l3.516-3.516L14.3 8.935a1.7 1.7 0 012.402 0l1.143 1.142 3.515 3.515z"
          fill="#7D61FF"
        />
        <path
          d="M14.621 16.406h1.758c.55 0 .996.446.996.996v4.16h-3.75v-4.16c0-.55.446-.996.996-.996z"
          fill="#E2E2E2"
        />
        <path
          d="M21.36 13.593v7.09a.879.879 0 01-.88.879h-.394a.87.87 0 00.102-.41v-7.09L15.53 9.402a1.694 1.694 0 00-1.202-.497 1.699 1.699 0 012.373.029l4.658 4.658z"
          fill="#5E44FF"
        />
        <path
          d="M17.375 17.402v4.16h-1.172v-4.16a.996.996 0 00-.996-.996h1.172c.55 0 .996.446.996.996z"
          fill="#ABABAB"
        />
        <path
          d="M22.863 14.433l-5.83-5.83a2.17 2.17 0 00-3.066 0l-5.83 5.83a.469.469 0 10.663.663l.372-.372v5.959a1.35 1.35 0 001.348 1.348h9.96a1.35 1.35 0 001.348-1.348v-5.959l.372.372a.467.467 0 00.663 0 .469.469 0 000-.663zm-8.77 6.66v-3.691c0-.291.237-.528.528-.528h1.758c.29 0 .527.237.527.528v3.691h-2.812zm6.798-.41a.41.41 0 01-.41.41h-2.637v-3.691c0-.808-.657-1.465-1.465-1.465H14.62c-.808 0-1.465.657-1.465 1.465v3.691H10.52a.41.41 0 01-.41-.41v-6.896l4.52-4.52c.48-.48 1.26-.48 1.74 0l4.52 4.52v6.896z"
          fill="#323232"
        />
      </g>
      <defs>
        <clipPath id="prefix__clip0">
          <path fill="#fff" transform="translate(8 7.5)" d="M0 0h15v15H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function EmptyGreyBlob(props: any) {
  return (
    <svg
      width="141"
      height="137"
      viewBox="0 0 141 137"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71.7322 0.116601C85.8168 1.08482 97.283 10.136 108.933 18.1233C120.959 26.3686 138.009 32.6841 140.269 47.1054C142.555 61.6921 127.313 72.4668 119.404 84.9269C113.767 93.807 109.171 103.126 100.732 109.394C92.2268 115.71 81.8128 117.085 71.7322 120.33C55.9389 125.413 38.5779 143.389 25.0687 133.746C11.6106 124.139 27.197 101.297 22.7387 85.3571C18.6021 70.568 -1.05952 61.5289 0.599055 46.2604C2.26088 30.9619 17.7317 21.1053 30.6268 12.7403C42.9577 4.74129 57.0758 -0.890926 71.7322 0.116601Z"
        fill="#E2E2E2"
      />
    </svg>
  );
}
export const ToriiPlum: React.FC<{}> = props => {
  return (
    <svg
      width={117}
      height={105}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.827.093C67.129.76 74.969 6.097 82.825 11.19c8.4 5.445 16.794 10.791 22.031 19.39 6.417 10.538 15.597 23.148 10.815 34.544-4.842 11.54-22.041 9.578-32.28 16.615-9.693 6.661-13.936 21.738-25.564 23.138-11.682 1.406-20.834-9.446-30.391-16.4-9.622-7.002-21.11-12.83-25.24-24.082C-2 52.959.2 39.777 5.557 28.852c4.929-10.055 14.836-16.076 24.57-21.432C38.725 2.69 48.07-.605 57.827.093Z"
        fill="#463264"
      />
    </svg>
  );
};

export const ToriiPlumTablet: React.FC<{}> = props => {
  return (
    <svg
      width={81}
      height={87}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.118.417c8.166-.211 15.04 5.339 21.669 10.124 6.66 4.807 13.811 9.698 16.54 17.457 2.76 7.85.24 16.237-1.861 24.29-2.237 8.572-4.15 17.624-10.642 23.634-6.924 6.409-16.335 10.998-25.706 10.01-9.066-.954-16.47-7.822-22.06-15.041-4.626-5.974-3.07-14.34-6.065-21.282C9.487 41.48-1.492 35.803.17 27.106c1.628-8.519 12.825-10.735 20.078-15.462C27.033 7.222 33.028.627 41.118.417Z"
        fill="#463264"
      />
    </svg>
  );
};

export const ToriiPlumMobile: React.FC<{}> = props => {
  return (
    <svg
      width={54}
      height={58}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.244.651c5.41-.14 9.965 3.537 14.357 6.708 4.412 3.185 9.151 6.425 10.959 11.566 1.829 5.202.159 10.758-1.233 16.094-1.482 5.68-2.749 11.678-7.051 15.66-4.588 4.246-10.823 7.287-17.032 6.633-6.007-.633-10.913-5.183-14.617-9.967-3.065-3.958-2.034-9.501-4.018-14.1C6.286 27.858-.99 24.096.113 18.334 1.19 12.69 8.61 11.221 13.416 8.09 17.91 5.16 21.884.79 27.244.65Z"
        fill="#463264"
      />
    </svg>
  );
};

export const Clementine: React.FC<{}> = props => {
  return (
    <svg
      width={104}
      height={117}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.984.006c9.853-.336 13.766 13.806 22.433 18.51 9.017 4.894 22.263 1.369 28.79 9.29 6.417 7.793 5.158 19.687 3.249 29.604-1.749 9.078-9.278 15.455-13.51 23.673-4.488 8.719-4.757 19.826-12.181 26.226-7.755 6.685-18.818 11.426-28.781 9.085-10.014-2.353-13.94-14.488-21.91-20.997-6.43-5.25-15.726-6.672-20.385-13.543C.927 74.83-.77 65.827.315 57.41 1.35 49.38 6.92 42.99 11.551 36.354c4.288-6.143 9.562-11.05 14.865-16.34C33.479 12.969 38.018.346 47.984.007Z"
        fill="#FF7350"
      />
    </svg>
  );
};

export const ClementineTablet: React.FC<{}> = props => {
  return (
    <svg
      width={106}
      height={105}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M54.37.155C70.8 1.907 76.517 21.577 86.01 35.125c8.29 11.832 21.93 22.692 18.614 36.76-3.305 14.019-19.83 18.614-33.02 24.355-12.24 5.327-24.911 10.723-37.521 6.349C19.577 97.557 6.626 87.062 2.474 72.26-1.895 56.682 3.53 40.462 12.977 27.336 23.127 13.233 37.11-1.686 54.37.155Z"
        fill="#FF7350"
      />
    </svg>
  );
};

export const ClementineMobile: React.FC<{}> = props => {
  return (
    <svg
      width={70}
      height={70}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.165.102C47.052 1.264 50.84 14.296 57.13 23.272c5.493 7.84 14.53 15.036 12.334 24.357-2.19 9.289-13.14 12.334-21.879 16.137-8.11 3.53-16.505 7.105-24.86 4.207C13.113 64.639 4.53 57.685 1.78 47.878c-2.895-10.322.7-21.069 6.959-29.766C15.465 8.768 24.729-1.118 36.165.102Z"
        fill="#FF7350"
      />
    </svg>
  );
};

export const Carnation: React.FC<{}> = props => {
  return (
    <svg
      width={145}
      height={93}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.442 91.808C19.625 87.332 3.677 71.33 1.221 53.097c-2.35-17.45 11.752-32.704 25.043-44.273C35.751.567 49.02.124 61.564.573 70.17.88 75.796 8.838 84.155 10.899c16.219 3.998 36.828-5.679 47.704 7.002 12.472 14.543 18.574 40.982 5.55 55.092-13.308 14.418-37.259-3.501-56.513.123-16.1 3.03-27.58 22.68-43.454 18.692Z"
        fill="#FFA0BE"
      />
    </svg>
  );
};

export const Sunshine: React.FC<{}> = props => {
  return (
    <svg
      width={51}
      height={57}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.211 9.669c3.787 3.902 4.18 9.763 4.837 15.16.66 5.421 1.5 11.121-1.055 15.946-2.585 4.881-7.814 7.418-12.69 10.01-5.192 2.76-10.471 5.893-16.333 5.417-6.25-.508-12.735-3.052-16.481-8.084C-.136 43.252-.125 36.538.875 30.555c.828-4.95 5.611-7.95 7.647-12.537 2.384-5.371.2-13.299 5.194-16.396C18.606-1.41 24.74 3.074 30.318 4.5c5.219 1.334 11.14 1.304 14.893 5.17Z"
        fill="#FFD750"
      />
    </svg>
  );
};

export const SunshineMini: React.FC<{}> = props => {
  return (
    <svg
      width={34}
      height={38}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.213 6.812c2.51 2.585 2.77 6.468 3.205 10.044.437 3.592.994 7.37-.699 10.566-1.713 3.234-5.177 4.915-8.408 6.633-3.44 1.828-6.938 3.904-10.822 3.589-4.141-.337-8.438-2.023-10.92-5.356C.168 29.063.174 24.615.837 20.65c.549-3.28 3.718-5.268 5.067-8.307 1.58-3.56.133-8.812 3.442-10.864 3.24-2.01 7.303.962 11 1.907 3.457.883 7.381.863 9.867 3.425Z"
        fill="#FFD750"
      />
    </svg>
  );
};

export const SunshineBackground: React.FC<{}> = props => {
  return (
    <svg
      width={270}
      height={700}
      viewBox="0 0 270 895"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M265.24 372.903c17.691 90.352-19.813 177.815-50.324 264.646-31.497 89.635-42.393 207.661-129.17 246.174-87.772 38.954-181.185-38.925-272.807-67.772-65.296-20.558-131.597-33.823-185.21-76.434-54.035-42.946-80.252-106.231-117.647-164.27-58.588-90.929-200.815-170.032-163.04-271.361 37.632-100.946 207.432-41.212 300.037-96.126C-267 156.81-243.405 17.743-144.691 2.49-45.784-12.792 42.247 68.07 116.56 135.22c71.061 64.211 130.272 143.664 148.68 237.683Z"
        fill="#FFD750"
      />
    </svg>
  );
};

export const SunshineCover: React.FC<{}> = props => {
  return (
    <svg
      width={146}
      height={131}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.16.116c11.607.83 21.392 7.49 31.195 13.844 10.48 6.793 20.956 13.463 27.491 24.191 8.008 13.147 19.463 28.88 13.496 43.098-6.042 14.397-27.505 11.95-40.283 20.729-12.094 8.311-17.389 27.12-31.899 28.867-14.578 1.755-25.998-11.785-37.924-20.462C22.23 101.649 7.894 94.378 2.74 80.339-2.495 66.073.249 49.627 6.932 35.997c6.151-12.545 18.515-20.057 30.662-26.74C48.322 3.356 59.984-.754 72.16.117Z"
        fill="#FFD750"
      />
    </svg>
  );
};

export const SavedSuccessIcon: React.FC<{}> = props => {
  return (
    <svg
      width={66}
      height={60}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.62.053c5.247.375 9.67 3.386 14.102 6.258 4.738 3.07 9.473 6.085 12.428 10.935 3.62 5.943 8.798 13.056 6.1 19.483-2.73 6.508-12.433 5.402-18.21 9.37-5.467 3.758-7.86 12.26-14.42 13.05-6.59.793-11.752-5.327-17.144-9.25C10.05 45.951 3.568 42.664 1.24 36.318c-2.367-6.45-1.127-13.884 1.895-20.045 2.78-5.671 8.37-9.067 13.86-12.088C21.845 1.517 27.117-.341 32.62.053Z"
        fill="#463264"
      />
    </svg>
  );
};

export const SavedSuccessCheckIcon: React.FC<{}> = props => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 3a13 13 0 1 0 13 13A13.015 13.015 0 0 0 16 3Zm6.191 10.724-7.334 7a1.003 1.003 0 0 1-1.382 0l-3.666-3.5a1 1 0 0 1 1.382-1.448l2.975 2.841 6.643-6.34a1 1 0 0 1 1.382 1.447Z"
        fill="#FFD750"
      />
    </svg>
  );
};

export function EmailVerificationIcon(props: any) {
  return (
    <svg
      width="88"
      height="79"
      viewBox="0 0 88 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.4938 0.0701539C50.4899 0.570478 56.3873 4.58482 62.296 8.41434C68.613 12.5084 74.9271 16.5287 78.866 22.9952C83.6927 30.9192 90.597 40.4024 87.0007 48.9719C83.3588 57.6499 70.4223 56.1746 62.7208 61.4663C55.4307 66.4753 52.2396 77.8127 43.4938 78.8654C34.7071 79.9231 27.8234 71.7621 20.6352 66.5324C13.399 61.2676 4.75795 56.8852 1.65208 48.4235C-1.50399 39.825 0.149927 29.9122 4.17828 21.6966C7.88581 14.1353 15.3377 9.60735 22.6596 5.57975C29.1259 2.02279 36.1547 -0.454693 43.4938 0.0701539Z"
        fill="#463264"
      />
      <path
        d="M77.6651 40.2996C77.6645 40.2749 77.6632 40.2503 77.6613 40.2258C77.6598 40.2057 77.6578 40.1858 77.6554 40.166C77.6525 40.1429 77.6489 40.12 77.6449 40.0972C77.6412 40.0765 77.6372 40.0559 77.6327 40.0356C77.6277 40.0139 77.622 39.9925 77.6161 39.971C77.6103 39.9504 77.6043 39.93 77.5975 39.9098C77.5906 39.8889 77.5829 39.8682 77.5748 39.8477C77.5671 39.8278 77.5592 39.8082 77.5506 39.7889C77.5415 39.7686 77.5318 39.7487 77.5217 39.7289C77.512 39.7098 77.5021 39.691 77.4916 39.6725C77.4808 39.6536 77.4694 39.6351 77.4576 39.6166C77.4457 39.5977 77.4333 39.5792 77.4203 39.561C77.4083 39.544 77.3958 39.5274 77.3829 39.5109C77.3682 39.4921 77.353 39.4739 77.3374 39.456C77.3301 39.4476 77.3238 39.4387 77.3162 39.4304C77.3098 39.4234 77.3027 39.4175 77.2962 39.4107C77.2801 39.3938 77.2634 39.3776 77.2465 39.3616C77.2308 39.3468 77.215 39.3322 77.1987 39.3182C77.1827 39.3045 77.1662 39.2916 77.1495 39.2786C77.1313 39.2645 77.1131 39.2504 77.0943 39.2374C77.0781 39.226 77.0612 39.2155 77.0444 39.2049C77.0246 39.1923 77.0048 39.1799 76.9845 39.1685C76.9667 39.1585 76.9484 39.1495 76.9301 39.1403C76.9102 39.1303 76.8903 39.1203 76.87 39.1113C76.8498 39.1024 76.829 39.0946 76.8083 39.0867C76.7891 39.0794 76.77 39.072 76.7506 39.0656C76.7284 39.0583 76.7057 39.0521 76.683 39.046C76.664 39.0408 76.645 39.0356 76.6258 39.0313C76.6032 39.0262 76.5802 39.0222 76.5572 39.0183C76.5368 39.0149 76.5165 39.0115 76.496 39.009C76.4741 39.0063 76.4522 39.0045 76.43 39.0029C76.4076 39.0013 76.3851 39 76.3626 38.9995C76.3528 38.9993 76.3432 38.998 76.3333 38.998H44.3333C44.3242 38.998 44.3154 38.9992 44.3063 38.9994C44.2821 38.9999 44.258 39.0013 44.2338 39.0031C44.2132 39.0046 44.1928 39.0062 44.1725 39.0087C44.1504 39.0114 44.1284 39.015 44.1065 39.0188C44.085 39.0225 44.0635 39.0262 44.0423 39.0308C44.0217 39.0355 44.0013 39.0411 43.9808 39.0467C43.9595 39.0525 43.9382 39.0583 43.9172 39.0652C43.8966 39.0719 43.8764 39.0798 43.856 39.0876C43.8364 39.0951 43.8167 39.1025 43.7975 39.1109C43.7764 39.1202 43.7556 39.1307 43.7348 39.1412C43.7173 39.1499 43.6998 39.1586 43.6828 39.1681C43.6619 39.1798 43.6415 39.1926 43.6212 39.2055C43.6049 39.2158 43.5886 39.226 43.5728 39.2371C43.5536 39.2504 43.5351 39.2647 43.5166 39.2791C43.5002 39.2918 43.4839 39.3046 43.4682 39.318C43.4518 39.3321 43.4359 39.3468 43.42 39.3618C43.4031 39.3777 43.3866 39.3939 43.3705 39.4107C43.3639 39.4175 43.3569 39.4234 43.3504 39.4304C43.3429 39.4387 43.3366 39.4476 43.3293 39.456C43.3136 39.4739 43.2985 39.4922 43.2838 39.5109C43.2708 39.5274 43.2584 39.544 43.2463 39.561C43.2334 39.5792 43.221 39.5977 43.2091 39.6166C43.1973 39.6351 43.1859 39.6537 43.1751 39.6725C43.1646 39.691 43.1547 39.7099 43.145 39.7289C43.1349 39.7488 43.1252 39.7686 43.1161 39.7889C43.1075 39.8082 43.0996 39.8279 43.0919 39.8477C43.0838 39.8683 43.0761 39.8889 43.0692 39.9098C43.0624 39.93 43.0564 39.9505 43.0506 39.971C43.0447 39.9925 43.039 40.0139 43.034 40.0356C43.0295 40.0559 43.0255 40.0765 43.0218 40.0972C43.0177 40.12 43.0142 40.143 43.0113 40.166C43.0089 40.1858 43.0069 40.2057 43.0054 40.2258C43.0034 40.2504 43.0022 40.275 43.0016 40.2996C43.0014 40.3103 43 40.3207 43 40.3314V62.9981C43.0008 63.705 43.282 64.3829 43.7819 64.8828C44.2819 65.3827 44.9597 65.6639 45.6667 65.6647H75C75.707 65.6639 76.3848 65.3827 76.8847 64.8828C77.3846 64.3829 77.6659 63.705 77.6667 62.9981V40.3314C77.6667 40.3206 77.6653 40.3103 77.6651 40.2996ZM75 62.9981H45.6667V43.3625L59.4323 55.981C59.6783 56.2064 59.9998 56.3314 60.3334 56.3314C60.667 56.3314 60.9885 56.2064 61.2344 55.981L75.0003 43.3622L75.0016 62.998L75 62.9981Z"
        fill="#C8BDDB"
      />
    </svg>
  );
}

export function PhoneVerificationIcon(props: any) {
  return (
    <svg
      width="88"
      height="79"
      viewBox="0 0 88 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.4938 0.0701539C50.4899 0.570478 56.3873 4.58482 62.296 8.41434C68.613 12.5084 74.9271 16.5287 78.866 22.9952C83.6927 30.9192 90.597 40.4024 87.0007 48.9719C83.3588 57.6499 70.4223 56.1746 62.7208 61.4663C55.4307 66.4753 52.2396 77.8127 43.4938 78.8654C34.7071 79.9231 27.8234 71.7621 20.6352 66.5324C13.399 61.2676 4.75795 56.8852 1.65208 48.4235C-1.50399 39.825 0.149927 29.9122 4.17828 21.6966C7.88581 14.1353 15.3377 9.60735 22.6596 5.57975C29.1259 2.02279 36.1547 -0.454693 43.4938 0.0701539Z"
        fill="#463264"
      />
      <path
        d="M75.995 57.4046L68.1886 54.059C67.7811 53.8836 67.3361 53.8129 66.8942 53.8535C66.4523 53.8941 66.0276 54.0447 65.6589 54.2915L61.485 57.0737C58.9341 55.833 56.8695 53.7775 55.6175 51.2321L55.6178 51.2317L58.3903 46.9954C58.6316 46.6276 58.778 46.2058 58.8164 45.7676C58.8548 45.3294 58.784 44.8885 58.6103 44.4843L55.2617 36.6713C55.0338 36.141 54.6402 35.6988 54.1399 35.4108C53.6395 35.1229 53.0594 35.0048 52.4863 35.0742C50.2344 35.3637 48.165 36.4632 46.6645 38.1671C45.1641 39.8711 44.3353 42.063 44.333 44.3335C44.333 57.5672 55.0993 68.3335 68.333 68.3335C70.6035 68.3312 72.7954 67.5023 74.4994 66.0019C76.2034 64.5014 77.3028 62.4319 77.5923 60.18C77.6615 59.6069 77.5433 59.0268 77.2553 58.5265C76.9674 58.0263 76.5252 57.6326 75.995 57.4046Z"
        fill="#C8BDDB"
      />
    </svg>
  );
}

export function CheckmarkBlob(props: any) {
  return (
    <svg
      width="88"
      height="79"
      viewBox="0 0 88 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.4938 0.0701539C50.4899 0.570478 56.3873 4.58482 62.296 8.41434C68.613 12.5084 74.9271 16.5287 78.866 22.9952C83.6927 30.9192 90.597 40.4024 87.0007 48.9719C83.3588 57.6499 70.4223 56.1746 62.7208 61.4663C55.4307 66.4753 52.2396 77.8127 43.4938 78.8654C34.7071 79.9231 27.8234 71.7621 20.6352 66.5324C13.399 61.2676 4.75795 56.8852 1.65208 48.4235C-1.50399 39.825 0.149927 29.9122 4.17828 21.6966C7.88581 14.1353 15.3377 9.60735 22.6596 5.57975C29.1259 2.02279 36.1547 -0.454693 43.4938 0.0701539Z"
        fill="#C8BDDB"
      />
      <path
        d="M61.3333 4C57.9051 4 54.5539 5.01658 51.7035 6.92119C48.853 8.8258 46.6313 11.5329 45.3194 14.7002C44.0075 17.8674 43.6643 21.3526 44.3331 24.7149C45.0019 28.0772 46.6527 31.1657 49.0768 33.5899C51.5009 36.014 54.5894 37.6648 57.9518 38.3336C61.3141 39.0024 64.7993 38.6592 67.9665 37.3472C71.1338 36.0353 73.8409 33.8137 75.7455 30.9632C77.6501 28.1128 78.6667 24.7615 78.6667 21.3333C78.6614 16.7379 76.8335 12.3322 73.584 9.08268C70.3345 5.8332 65.9288 4.00531 61.3333 4ZM69.5886 18.2982L59.8099 27.6315C59.5613 27.8681 59.2312 28 58.888 28C58.5448 28 58.2148 27.8681 57.9662 27.6315L53.0781 22.9648C52.8228 22.7202 52.6749 22.3842 52.6671 22.0307C52.6593 21.6772 52.7921 21.335 53.0364 21.0793C53.2807 20.8236 53.6165 20.6754 53.97 20.6671C54.3235 20.6588 54.6659 20.7912 54.9219 21.0352L58.888 24.8229L67.7448 16.3685C68.0008 16.1245 68.3432 15.9921 68.6967 16.0004C69.0502 16.0087 69.386 16.1569 69.6303 16.4126C69.8746 16.6683 70.0074 17.0105 69.9996 17.364C69.9918 17.7176 69.8439 18.0536 69.5886 18.2982Z"
        fill="#443461"
      />
    </svg>
  );
}

export function DocumentBlob(props: any) {
  return (
    <svg
      width="88"
      height="79"
      viewBox="0 0 88 79"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.4938 0.0701539C50.4899 0.570478 56.3873 4.58482 62.296 8.41434C68.613 12.5084 74.9271 16.5287 78.866 22.9952C83.6927 30.9192 90.597 40.4024 87.0007 48.9719C83.3588 57.6499 70.4223 56.1746 62.7208 61.4663C55.4307 66.4753 52.2396 77.8127 43.4938 78.8654C34.7071 79.9231 27.8234 71.7621 20.6352 66.5324C13.399 61.2676 4.75795 56.8852 1.65208 48.4235C-1.50399 39.825 0.149927 29.9122 4.17828 21.6966C7.88581 14.1353 15.3377 9.60735 22.6596 5.57975C29.1259 2.02279 36.1547 -0.454693 43.4938 0.0701539Z"
        fill="#443461"
      />
      <path
        d="M74.2649 39.0457L64.9429 29.7237C64.9295 29.7104 64.915 29.6986 64.9012 29.686C64.8832 29.6694 64.8657 29.6523 64.8468 29.6368C64.8343 29.6265 64.8209 29.6176 64.808 29.6077C64.7862 29.5911 64.7646 29.5741 64.7419 29.5588C64.7315 29.5518 64.7205 29.5461 64.7101 29.5395C64.6837 29.5228 64.6572 29.5062 64.6296 29.4913C64.6221 29.4873 64.6143 29.4842 64.6068 29.4804C64.5755 29.4643 64.5439 29.4488 64.5113 29.4352C64.5063 29.4331 64.5009 29.4316 64.4958 29.4295C64.4607 29.4154 64.4251 29.4023 64.3887 29.3912C64.3834 29.3896 64.3779 29.3886 64.3726 29.387C64.3365 29.3765 64.3 29.3669 64.2625 29.3594C64.2506 29.357 64.2384 29.356 64.2264 29.3539C64.1955 29.3485 64.1647 29.3431 64.1332 29.34C64.089 29.3355 64.0445 29.3333 64 29.3333H47.9987C47.2917 29.3341 46.6139 29.6153 46.114 30.1152C45.6141 30.6151 45.3328 31.2929 45.332 31.9999V61.3333C45.3328 62.0402 45.6141 62.7181 46.114 63.218C46.6139 63.7179 47.2917 63.9991 47.9987 63.9999H72C72.707 63.9991 73.3848 63.7179 73.8847 63.218C74.3846 62.7181 74.6659 62.0402 74.6667 61.3333V40.0257C74.6668 40.017 74.668 40.0086 74.668 39.9999C74.6681 39.822 74.6325 39.6458 74.5633 39.4819C74.494 39.318 74.3926 39.1697 74.2649 39.0457ZM65.3333 54.6666H54.6667C54.313 54.6666 53.9739 54.5261 53.7239 54.2761C53.4738 54.026 53.3333 53.6869 53.3333 53.3333C53.3333 52.9796 53.4738 52.6405 53.7239 52.3904C53.9739 52.1404 54.313 51.9999 54.6667 51.9999H65.3333C65.687 51.9999 66.0261 52.1404 66.2761 52.3904C66.5262 52.6405 66.6667 52.9796 66.6667 53.3333C66.6667 53.6869 66.5262 54.026 66.2761 54.2761C66.0261 54.5261 65.687 54.6666 65.3333 54.6666ZM65.3333 49.3333H54.6667C54.313 49.3333 53.9739 49.1928 53.7239 48.9427C53.4738 48.6927 53.3333 48.3535 53.3333 47.9999C53.3333 47.6463 53.4738 47.3072 53.7239 47.0571C53.9739 46.8071 54.313 46.6666 54.6667 46.6666H65.3333C65.687 46.6666 66.0261 46.8071 66.2761 47.0571C66.5262 47.3072 66.6667 47.6463 66.6667 47.9999C66.6667 48.3535 66.5262 48.6927 66.2761 48.9427C66.0261 49.1928 65.687 49.3333 65.3333 49.3333ZM64 39.9999V32.5522L71.4476 39.9999H64Z"
        fill="#C8BDDB"
      />
    </svg>
  );
}

export function PaperClipBlob(props: any) {
  return (
    <svg
      width="88"
      height="82"
      viewBox="0 0 88 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.4938 2.7369C50.4899 3.23723 56.3873 7.25157 62.296 11.0811C68.613 15.1752 74.9271 19.1954 78.866 25.662C83.6927 33.5859 90.597 43.0692 87.0007 51.6386C83.3588 60.3166 70.4223 58.8414 62.7208 64.1331C55.4307 69.1421 52.2396 80.4794 43.4938 81.5322C34.7071 82.5899 27.8234 74.4289 20.6352 69.1991C13.399 63.9344 4.75795 59.5519 1.65208 51.0902C-1.50399 42.4917 0.149927 32.579 4.17828 24.3634C7.88581 16.802 15.3377 12.2741 22.6596 8.2465C29.1259 4.68954 36.1547 2.21205 43.4938 2.7369Z"
        fill="#C8BDDB"
      />
      <path
        d="M78.9424 20.3903C79.1923 20.6405 79.3326 20.9797 79.3323 21.3333C79.3321 21.6869 79.1914 22.0259 78.9412 22.2758L65.2657 35.9335C64.399 36.8002 63.37 37.4876 62.2376 37.9566C61.1052 38.4256 59.8915 38.6669 58.6659 38.6669C56.1905 38.6667 53.8166 37.6833 52.0663 35.9329C50.3161 34.1824 49.3329 31.8084 49.333 29.333C49.3331 26.8577 50.3166 24.4838 52.067 22.7335L68.6118 5.95845C69.2302 5.33816 69.9648 4.84582 70.7736 4.50956C71.5825 4.17331 72.4496 3.99975 73.3255 3.99878C74.2014 3.99782 75.069 4.16948 75.8785 4.50395C76.688 4.83842 77.4237 5.32915 78.0435 5.94808C78.6633 6.56702 79.1551 7.30203 79.4907 8.1111C79.8263 8.92018 79.9992 9.78746 79.9994 10.6634C79.9997 11.5393 79.8273 12.4067 79.4922 13.216C79.1571 14.0252 78.6658 14.7605 78.0464 15.3798L61.5015 32.1551C61.1306 32.5273 60.69 32.8228 60.2048 33.0247C59.7197 33.2266 59.1995 33.331 58.674 33.3317C58.1485 33.3325 57.628 33.2298 57.1422 33.0293C56.6564 32.8288 56.2149 32.5346 55.8429 32.1635C55.4709 31.7923 55.1757 31.3515 54.9741 30.8662C54.7725 30.3809 54.6685 29.8606 54.6681 29.3351C54.6677 28.8096 54.7708 28.2892 54.9716 27.8035C55.1724 27.3179 55.4669 26.8766 55.8383 26.5048L69.7151 12.3974C69.9631 12.1453 70.3011 12.0021 70.6547 11.9992C71.0083 11.9963 71.3486 12.134 71.6007 12.382C71.8528 12.6299 71.9961 12.9679 71.999 13.3215C72.0019 13.6752 71.8642 14.0154 71.6162 14.2675L57.7316 28.3828C57.6063 28.5058 57.5065 28.6525 57.438 28.8142C57.3695 28.976 57.3337 29.1496 57.3325 29.3253C57.3313 29.5009 57.3649 29.6751 57.4313 29.8377C57.4976 30.0003 57.5954 30.1483 57.7191 30.273C57.8428 30.3977 57.9899 30.4967 58.152 30.5644C58.3141 30.6321 58.4879 30.6671 58.6636 30.6674C58.8392 30.6677 59.0132 30.6333 59.1755 30.5661C59.3378 30.499 59.4852 30.4005 59.6093 30.2762L76.1543 13.5008C76.5268 13.1299 76.8227 12.6893 77.0248 12.204C77.2269 11.7188 77.3315 11.1984 77.3324 10.6728C77.3333 10.1471 77.2306 9.62638 77.0301 9.14043C76.8296 8.65449 76.5353 8.21282 76.1641 7.84069C75.7928 7.46855 75.3518 7.17325 74.8663 6.97167C74.3808 6.77009 73.8603 6.66618 73.3347 6.66589C72.809 6.6656 72.2884 6.76892 71.8027 6.96996C71.317 7.171 70.8757 7.4658 70.504 7.83752L53.9591 24.6126C53.3388 25.231 52.8465 25.9657 52.5102 26.7745C52.1739 27.5833 52.0004 28.4505 51.9994 29.3264C51.9985 30.2023 52.1701 31.0699 52.5046 31.8794C52.8391 32.689 53.3298 33.4247 53.9488 34.0445C54.5677 34.6643 55.3027 35.1561 56.1118 35.4917C56.9209 35.8273 57.7882 36.0002 58.6641 36.0004C59.5401 36.0007 60.4075 35.8283 61.2167 35.4932C62.026 35.1581 62.7614 34.6668 63.3807 34.0473L77.0568 20.3891C77.1807 20.2654 77.3277 20.1672 77.4895 20.1003C77.6513 20.0333 77.8247 19.999 77.9998 19.9991C78.1749 19.9992 78.3483 20.0338 78.5101 20.1009C78.6718 20.168 78.8187 20.2663 78.9424 20.3903Z"
        fill="#443461"
      />
    </svg>
  );
}

export function SmileyBlob(props: any) {
  return (
    <svg
      width="119"
      height="98"
      viewBox="0 0 119 98"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.3511 11.4551C62.1601 10.1427 68.819 12.4672 75.4414 14.6123C82.5214 16.9056 89.5798 19.1291 94.9959 24.2964C101.633 30.6283 110.653 37.9177 109.411 47.0213C108.154 56.2403 95.4224 58.1416 89.4219 65.1656C83.7419 71.8143 83.5955 83.4574 75.5131 86.7006C67.393 89.959 58.7311 83.927 50.5286 80.7722C42.2712 77.5962 32.8981 75.6222 27.767 68.3364C22.5529 60.9329 21.5959 51.0435 23.3406 42.1673C24.9463 33.9979 30.9038 27.7672 36.8653 22.0475C42.1302 16.9962 48.2084 12.8318 55.3511 11.4551Z"
        fill="#443461"
      />
      <path
        d="M79.4185 40C75.5617 40 71.7916 41.1437 68.5848 43.2863C65.3781 45.429 62.8787 48.4745 61.4028 52.0377C59.9269 55.6008 59.5407 59.5216 60.2932 63.3043C61.0456 67.0869 62.9028 70.5615 65.6299 73.2886C68.357 76.0157 71.8316 77.8729 75.6142 78.6253C79.3968 79.3777 83.3176 78.9916 86.8808 77.5156C90.444 76.0397 93.4894 73.5404 95.6321 70.3336C97.7748 67.1269 98.9185 63.3567 98.9185 59.5C98.9125 54.3301 96.8561 49.3737 93.2004 45.718C89.5448 42.0624 84.5884 40.006 79.4185 40ZM86.1685 53.5C86.6135 53.5 87.0485 53.632 87.4185 53.8792C87.7885 54.1264 88.0769 54.4778 88.2472 54.889C88.4175 55.3001 88.462 55.7525 88.3752 56.189C88.2884 56.6254 88.0741 57.0263 87.7595 57.341C87.4448 57.6557 87.0439 57.87 86.6074 57.9568C86.171 58.0436 85.7186 57.999 85.3074 57.8287C84.8963 57.6584 84.5449 57.37 84.2977 57C84.0504 56.63 83.9185 56.195 83.9185 55.75C83.9185 55.1533 84.1556 54.581 84.5775 54.159C84.9995 53.7371 85.5717 53.5 86.1685 53.5ZM72.6685 53.5C73.1135 53.5 73.5485 53.632 73.9185 53.8792C74.2885 54.1264 74.5769 54.4778 74.7472 54.889C74.9175 55.3001 74.962 55.7525 74.8752 56.189C74.7884 56.6254 74.5741 57.0263 74.2595 57.341C73.9448 57.6557 73.5439 57.87 73.1074 57.9568C72.671 58.0436 72.2186 57.999 71.8074 57.8287C71.3963 57.6584 71.0449 57.37 70.7977 57C70.5504 56.63 70.4185 56.195 70.4185 55.75C70.4185 55.1533 70.6556 54.581 71.0775 54.159C71.4995 53.7371 72.0717 53.5 72.6685 53.5ZM88.5122 64.7515C87.3678 66.7291 85.6116 68.2811 83.5083 69.1738C81.1491 70.1679 78.5083 70.2672 76.0811 69.453C73.654 68.6388 71.6072 66.9671 70.3247 64.7515C70.226 64.581 70.1619 64.3928 70.1359 64.1976C70.11 64.0024 70.1227 63.8039 70.1735 63.6136C70.2242 63.4233 70.3119 63.2449 70.4316 63.0885C70.5513 62.9321 70.7007 62.8008 70.8711 62.7021C71.0415 62.6035 71.2297 62.5393 71.425 62.5134C71.6202 62.4874 71.8186 62.5002 72.0089 62.5509C72.1992 62.6017 72.3777 62.6894 72.5341 62.8091C72.6904 62.9288 72.8217 63.0781 72.9204 63.2485C73.7401 64.6624 74.9964 65.7721 76.5005 66.4111C77.4255 66.797 78.4177 66.9956 79.4199 66.9956C80.4221 66.9956 81.4144 66.797 82.3394 66.4111C83.2296 66.0335 84.0383 65.4874 84.7212 64.8027C85.1846 64.3381 85.5863 63.8157 85.9165 63.2485C86.0152 63.0781 86.1465 62.9288 86.3029 62.8091C86.4593 62.6894 86.6377 62.6017 86.828 62.5509C87.0183 62.5002 87.2167 62.4874 87.412 62.5134C87.6072 62.5393 87.7954 62.6035 87.9658 62.7021C88.1363 62.8008 88.2856 62.9321 88.4053 63.0885C88.525 63.2449 88.6127 63.4233 88.6634 63.6136C88.7142 63.8039 88.7269 64.0024 88.701 64.1976C88.675 64.3928 88.6109 64.581 88.5122 64.7515Z"
        fill="#C8BDDB"
      />
      <path
        d="M52.2185 30.568C51.8913 30.4476 46.2215 28.4206 39.1944 29.5079C37.265 26.9244 34.7506 25.0063 31.9538 24.0159C28.0319 22.6274 23.8214 23.1275 19.7776 25.4622C11.7597 30.0913 10.6833 40.2953 10.6414 40.7274C10.6043 41.1068 10.7195 41.4854 10.9616 41.78C11.2037 42.0745 11.5529 42.2608 11.9323 42.2979C12.3118 42.335 12.6904 42.2198 12.9849 41.9777C13.2795 41.7357 13.4658 41.3865 13.5028 41.007C13.5119 40.9158 14.4945 31.8322 21.2151 27.952C24.5081 26.0508 27.8896 25.6269 30.994 26.7261C32.942 27.443 34.6793 28.6364 36.0475 30.1974C34.1116 30.7508 32.2509 31.5397 30.5072 32.5465C26.4519 34.8879 23.6591 37.9131 22.4311 41.295C21.3449 44.2866 21.561 47.4558 23.0241 49.99C23.5816 50.978 24.3301 51.8451 25.2259 52.5409C26.1218 53.2368 27.1472 53.7474 28.2424 54.0431C30.6096 54.6713 33.1504 54.2588 35.5901 52.8503C39.5151 50.5842 41.9592 47.1032 42.6579 42.7838C43.2126 39.3548 42.5627 35.5567 40.8721 32.216C46.6362 31.6408 51.1607 33.2424 51.2261 33.2662C51.4034 33.3318 51.5918 33.3617 51.7806 33.3543C51.9695 33.3469 52.155 33.3024 52.3266 33.2232C52.4982 33.1441 52.6525 33.0319 52.7807 32.8931C52.9089 32.7542 53.0084 32.5915 53.0736 32.4141C53.1389 32.2368 53.1685 32.0483 53.1608 31.8595C53.1531 31.6707 53.1083 31.4852 53.0289 31.3137C52.9494 31.1423 52.837 30.9882 52.6979 30.8602C52.5589 30.7322 52.396 30.6329 52.2185 30.568L52.2185 30.568ZM34.1526 50.3604C30.2177 52.6322 26.9786 51.0894 25.5139 48.5525C23.4694 45.0113 24.6098 39.2712 31.9447 35.0363C33.7937 33.972 35.7904 33.1879 37.8696 32.7098C37.8794 32.7268 37.8895 32.744 37.8993 32.761C41.2209 38.5141 41.0005 46.4068 34.1526 50.3604Z"
        fill="#FAD96A"
      />
      <path
        d="M88 13.0006L74 27L67 20.0006"
        stroke="#96C471"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SunnyKitchen(props: any) {
  return (
    <svg
      width={185}
      height={187}
      viewBox="0 0 185 187"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M185 131.118c0-19.332-12.586-33.564-31.938-41.538-24.668-10.18-39.639-24.225-44.926-47.458C102.307 16.482 84.531 0 59.853 0 27.986 0 0 38.699 0 83.252c0 57.874 40.36 103.017 103.565 103.017 40.531 0 81.435-25.831 81.435-55.151Z"
        fill="#FFD750"
      />
      <path
        d="M45.148 99.216c1.68 0 3.064-.208 4.152-.624 1.088-.432 1.888-1.016 2.4-1.752.272-.368.472-.76.6-1.176.128-.432.192-.888.192-1.368 0-1.04-.264-1.84-.792-2.4-.512-.576-1.24-.992-2.184-1.248-.464-.128-.976-.24-1.536-.336a19.15 19.15 0 0 0-1.8-.216c-1.264-.112-2.192-.232-2.784-.36-.576-.144-.864-.408-.864-.792 0-.32.152-.584.456-.792.304-.208.856-.312 1.656-.312.8 0 1.432.12 1.896.36.464.24.76.6.888 1.08h4.92c-.352-1.52-1.128-2.688-2.328-3.504-1.2-.832-2.96-1.248-5.28-1.248-2.272 0-3.992.44-5.16 1.32-1.152.864-1.728 2.008-1.728 3.432 0 1.04.256 1.848.768 2.424.528.56 1.256.96 2.184 1.2.464.128.968.24 1.512.336.544.08 1.12.144 1.728.192 1.248.096 2.176.216 2.784.36.608.128.912.4.912.816 0 .352-.176.632-.528.84-.336.208-.904.312-1.704.312-.896 0-1.584-.128-2.064-.384s-.808-.656-.984-1.2H37.3c.272 1.696 1.072 2.96 2.4 3.792 1.344.832 3.16 1.248 5.448 1.248Zm19.183-.408h4.176v-13.92h-4.992v6.864c0 .976-.184 1.752-.552 2.328-.352.576-.952.864-1.8.864-.88 0-1.472-.256-1.776-.768-.304-.528-.456-1.256-.456-2.184v-7.104h-4.92v8.496c0 1.808.424 3.216 1.272 4.224.864 1.008 2.16 1.512 3.888 1.512 1.232 0 2.232-.272 3-.816.768-.544 1.328-1.28 1.68-2.208l.48 2.712Zm11.62-6.768c0-1.072.191-1.888.575-2.448.4-.576 1.064-.864 1.992-.864.896 0 1.504.264 1.824.792.336.512.504 1.248.504 2.208v7.08h4.944v-8.496c0-1.808-.456-3.216-1.368-4.224-.912-1.024-2.232-1.536-3.96-1.536-1.216 0-2.232.272-3.048.816-.8.544-1.4 1.272-1.8 2.184l-.456-2.664h-4.2v13.92h4.992V92.04Zm17.18 0c0-1.072.191-1.888.575-2.448.4-.576 1.064-.864 1.992-.864.896 0 1.504.264 1.824.792.336.512.504 1.248.504 2.208v7.08h4.944v-8.496c0-1.808-.456-3.216-1.368-4.224-.912-1.024-2.232-1.536-3.96-1.536-1.216 0-2.232.272-3.048.816-.8.544-1.4 1.272-1.8 2.184l-.456-2.664h-4.2v13.92h4.992V92.04Zm13.709 12.288c1.008 0 1.848-.064 2.52-.192.672-.112 1.248-.336 1.728-.672.48-.352.928-.856 1.344-1.512.416-.656.864-1.52 1.344-2.592l6.432-14.472h-5.064l-3.264 8.064-3.312-8.064h-5.208l6.024 13.224-.192.432c-.208.464-.424.824-.648 1.08a1.586 1.586 0 0 1-.84.528c-.16.064-.36.104-.6.12a5.48 5.48 0 0 1-.768.048h-1.944v4.008h2.448Zm-69.342 24.48h5.568l-5.28-8.568 5.088-5.352H37.09l-5.112 5.376v-9.888H27.13v18.432h4.848v-3.72l2.064-2.184 3.456 5.904Zm8.888-14.76c.992 0 1.728-.176 2.208-.528.48-.352.72-.944.72-1.776 0-.864-.256-1.464-.768-1.8-.496-.352-1.216-.528-2.16-.528-.96 0-1.688.176-2.184.528-.496.336-.744.936-.744 1.8s.224 1.464.672 1.8c.448.336 1.2.504 2.256.504Zm-2.568 14.76h5.088V114.96c-.096.064-.296.128-.6.192-.288.048-.608.088-.96.12-.192.016-.368.032-.528.048h-.456c-.272 0-.592-.008-.96-.024a8.477 8.477 0 0 1-1.008-.144 1.78 1.78 0 0 1-.36-.072 2.135 2.135 0 0 1-.216-.12v13.848Zm18.149-4.296h-1.488c-.72 0-1.264-.056-1.632-.168-.352-.128-.592-.384-.72-.768a3.56 3.56 0 0 1-.144-.72 10.215 10.215 0 0 1-.048-1.056v-2.712h4.032v-4.2h-4.032v-3.624h-3.936c-.016.336-.04.696-.072 1.08a5.26 5.26 0 0 1-.144 1.056c-.112.512-.272.88-.48 1.104-.192.224-.504.376-.936.456a7.076 7.076 0 0 1-.84.144c-.272.016-.584.032-.936.048v3.936h2.712v3.456c0 1.52.16 2.744.48 3.672.336.912.92 1.576 1.752 1.992.416.192.92.344 1.512.456.592.096 1.272.144 2.04.144h2.88v-4.296Zm9.047 4.704c2.432 0 4.352-.536 5.76-1.608 1.408-1.088 2.16-2.696 2.256-4.824v-.072h-5.16v.024c-.096.8-.376 1.4-.84 1.8-.464.4-1.12.6-1.968.6-.944 0-1.672-.256-2.184-.768-.512-.528-.768-1.296-.768-2.304v-.216c0-1.104.264-1.928.792-2.472s1.256-.816 2.184-.816c.848 0 1.496.192 1.944.576.448.368.728.952.84 1.752v.048h5.16v-.024c-.128-2.096-.896-3.68-2.304-4.752-1.408-1.072-3.296-1.608-5.664-1.608-1.584 0-2.976.288-4.176.864-1.184.576-2.104 1.408-2.76 2.496a6.714 6.714 0 0 0-.768 1.8 9.002 9.002 0 0 0-.24 2.136v.24c0 2.288.648 4.048 1.944 5.28 1.296 1.232 3.28 1.848 5.952 1.848Zm14.59-7.176c0-1.072.2-1.896.6-2.472.4-.576 1.056-.864 1.968-.864.896 0 1.504.28 1.824.84.336.544.504 1.28.504 2.208v7.056h4.944v-8.52c0-1.808-.432-3.216-1.296-4.224-.864-1.008-2.176-1.512-3.936-1.512-1.088 0-2.024.24-2.808.72a4.833 4.833 0 0 0-1.824 1.896v-6.792h-4.872v18.432h4.896v-6.768Zm19.822-3.912c.896 0 1.584.192 2.064.576.496.384.808.952.936 1.704h-6.24c.176-.736.528-1.296 1.056-1.68.528-.4 1.256-.6 2.184-.6Zm7.776 6.264h-5.256a2.24 2.24 0 0 1-.864.864c-.384.208-.936.312-1.656.312-.992 0-1.76-.2-2.304-.6-.528-.416-.856-1.016-.984-1.8h11.16v-1.464c0-1.344-.28-2.552-.84-3.624-.544-1.088-1.4-1.944-2.568-2.568a7.14 7.14 0 0 0-1.992-.72c-.736-.16-1.56-.24-2.472-.24-1.744 0-3.224.312-4.44.936-1.2.608-2.12 1.472-2.76 2.592a7.136 7.136 0 0 0-.696 1.8 8.49 8.49 0 0 0-.24 2.064v.24c0 1.392.264 2.616.792 3.672s1.376 1.88 2.544 2.472c.576.304 1.248.528 2.016.672.768.144 1.624.216 2.568.216 2.272 0 4.056-.416 5.352-1.248 1.296-.832 2.176-2.024 2.64-3.576Zm6.928-2.352c0-1.072.192-1.888.576-2.448.4-.576 1.064-.864 1.992-.864.896 0 1.504.264 1.824.792.336.512.504 1.248.504 2.208v7.08h4.944v-8.496c0-1.808-.456-3.216-1.368-4.224-.912-1.024-2.232-1.536-3.96-1.536-1.216 0-2.232.272-3.048.816-.8.544-1.4 1.272-1.8 2.184l-.456-2.664h-4.2v13.92h4.992v-6.768Z"
        fill="#2D2332"
      />
      <path
        d="M45.148 99.216c1.68 0 3.064-.208 4.152-.624 1.088-.432 1.888-1.016 2.4-1.752.272-.368.472-.76.6-1.176.128-.432.192-.888.192-1.368 0-1.04-.264-1.84-.792-2.4-.512-.576-1.24-.992-2.184-1.248-.464-.128-.976-.24-1.536-.336a19.15 19.15 0 0 0-1.8-.216c-1.264-.112-2.192-.232-2.784-.36-.576-.144-.864-.408-.864-.792 0-.32.152-.584.456-.792.304-.208.856-.312 1.656-.312.8 0 1.432.12 1.896.36.464.24.76.6.888 1.08h4.92c-.352-1.52-1.128-2.688-2.328-3.504-1.2-.832-2.96-1.248-5.28-1.248-2.272 0-3.992.44-5.16 1.32-1.152.864-1.728 2.008-1.728 3.432 0 1.04.256 1.848.768 2.424.528.56 1.256.96 2.184 1.2.464.128.968.24 1.512.336.544.08 1.12.144 1.728.192 1.248.096 2.176.216 2.784.36.608.128.912.4.912.816 0 .352-.176.632-.528.84-.336.208-.904.312-1.704.312-.896 0-1.584-.128-2.064-.384s-.808-.656-.984-1.2H37.3c.272 1.696 1.072 2.96 2.4 3.792 1.344.832 3.16 1.248 5.448 1.248Zm19.183-.408h4.176v-13.92h-4.992v6.864c0 .976-.184 1.752-.552 2.328-.352.576-.952.864-1.8.864-.88 0-1.472-.256-1.776-.768-.304-.528-.456-1.256-.456-2.184v-7.104h-4.92v8.496c0 1.808.424 3.216 1.272 4.224.864 1.008 2.16 1.512 3.888 1.512 1.232 0 2.232-.272 3-.816.768-.544 1.328-1.28 1.68-2.208l.48 2.712Zm11.62-6.768c0-1.072.191-1.888.575-2.448.4-.576 1.064-.864 1.992-.864.896 0 1.504.264 1.824.792.336.512.504 1.248.504 2.208v7.08h4.944v-8.496c0-1.808-.456-3.216-1.368-4.224-.912-1.024-2.232-1.536-3.96-1.536-1.216 0-2.232.272-3.048.816-.8.544-1.4 1.272-1.8 2.184l-.456-2.664h-4.2v13.92h4.992V92.04Zm17.18 0c0-1.072.191-1.888.575-2.448.4-.576 1.064-.864 1.992-.864.896 0 1.504.264 1.824.792.336.512.504 1.248.504 2.208v7.08h4.944v-8.496c0-1.808-.456-3.216-1.368-4.224-.912-1.024-2.232-1.536-3.96-1.536-1.216 0-2.232.272-3.048.816-.8.544-1.4 1.272-1.8 2.184l-.456-2.664h-4.2v13.92h4.992V92.04Zm13.709 12.288c1.008 0 1.848-.064 2.52-.192.672-.112 1.248-.336 1.728-.672.48-.352.928-.856 1.344-1.512.416-.656.864-1.52 1.344-2.592l6.432-14.472h-5.064l-3.264 8.064-3.312-8.064h-5.208l6.024 13.224-.192.432c-.208.464-.424.824-.648 1.08a1.586 1.586 0 0 1-.84.528c-.16.064-.36.104-.6.12a5.48 5.48 0 0 1-.768.048h-1.944v4.008h2.448Zm-69.342 24.48h5.568l-5.28-8.568 5.088-5.352H37.09l-5.112 5.376v-9.888H27.13v18.432h4.848v-3.72l2.064-2.184 3.456 5.904Zm8.888-14.76c.992 0 1.728-.176 2.208-.528.48-.352.72-.944.72-1.776 0-.864-.256-1.464-.768-1.8-.496-.352-1.216-.528-2.16-.528-.96 0-1.688.176-2.184.528-.496.336-.744.936-.744 1.8s.224 1.464.672 1.8c.448.336 1.2.504 2.256.504Zm-2.568 14.76h5.088V114.96c-.096.064-.296.128-.6.192-.288.048-.608.088-.96.12-.192.016-.368.032-.528.048h-.456c-.272 0-.592-.008-.96-.024a8.477 8.477 0 0 1-1.008-.144 1.78 1.78 0 0 1-.36-.072 2.135 2.135 0 0 1-.216-.12v13.848Zm18.149-4.296h-1.488c-.72 0-1.264-.056-1.632-.168-.352-.128-.592-.384-.72-.768a3.56 3.56 0 0 1-.144-.72 10.215 10.215 0 0 1-.048-1.056v-2.712h4.032v-4.2h-4.032v-3.624h-3.936c-.016.336-.04.696-.072 1.08a5.26 5.26 0 0 1-.144 1.056c-.112.512-.272.88-.48 1.104-.192.224-.504.376-.936.456a7.076 7.076 0 0 1-.84.144c-.272.016-.584.032-.936.048v3.936h2.712v3.456c0 1.52.16 2.744.48 3.672.336.912.92 1.576 1.752 1.992.416.192.92.344 1.512.456.592.096 1.272.144 2.04.144h2.88v-4.296Zm9.047 4.704c2.432 0 4.352-.536 5.76-1.608 1.408-1.088 2.16-2.696 2.256-4.824v-.072h-5.16v.024c-.096.8-.376 1.4-.84 1.8-.464.4-1.12.6-1.968.6-.944 0-1.672-.256-2.184-.768-.512-.528-.768-1.296-.768-2.304v-.216c0-1.104.264-1.928.792-2.472s1.256-.816 2.184-.816c.848 0 1.496.192 1.944.576.448.368.728.952.84 1.752v.048h5.16v-.024c-.128-2.096-.896-3.68-2.304-4.752-1.408-1.072-3.296-1.608-5.664-1.608-1.584 0-2.976.288-4.176.864-1.184.576-2.104 1.408-2.76 2.496a6.714 6.714 0 0 0-.768 1.8 9.002 9.002 0 0 0-.24 2.136v.24c0 2.288.648 4.048 1.944 5.28 1.296 1.232 3.28 1.848 5.952 1.848Zm14.59-7.176c0-1.072.2-1.896.6-2.472.4-.576 1.056-.864 1.968-.864.896 0 1.504.28 1.824.84.336.544.504 1.28.504 2.208v7.056h4.944v-8.52c0-1.808-.432-3.216-1.296-4.224-.864-1.008-2.176-1.512-3.936-1.512-1.088 0-2.024.24-2.808.72a4.833 4.833 0 0 0-1.824 1.896v-6.792h-4.872v18.432h4.896v-6.768Zm19.822-3.912c.896 0 1.584.192 2.064.576.496.384.808.952.936 1.704h-6.24c.176-.736.528-1.296 1.056-1.68.528-.4 1.256-.6 2.184-.6Zm7.776 6.264h-5.256a2.24 2.24 0 0 1-.864.864c-.384.208-.936.312-1.656.312-.992 0-1.76-.2-2.304-.6-.528-.416-.856-1.016-.984-1.8h11.16v-1.464c0-1.344-.28-2.552-.84-3.624-.544-1.088-1.4-1.944-2.568-2.568a7.14 7.14 0 0 0-1.992-.72c-.736-.16-1.56-.24-2.472-.24-1.744 0-3.224.312-4.44.936-1.2.608-2.12 1.472-2.76 2.592a7.136 7.136 0 0 0-.696 1.8 8.49 8.49 0 0 0-.24 2.064v.24c0 1.392.264 2.616.792 3.672s1.376 1.88 2.544 2.472c.576.304 1.248.528 2.016.672.768.144 1.624.216 2.568.216 2.272 0 4.056-.416 5.352-1.248 1.296-.832 2.176-2.024 2.64-3.576Zm6.928-2.352c0-1.072.192-1.888.576-2.448.4-.576 1.064-.864 1.992-.864.896 0 1.504.264 1.824.792.336.512.504 1.248.504 2.208v7.08h4.944v-8.496c0-1.808-.456-3.216-1.368-4.224-.912-1.024-2.232-1.536-3.96-1.536-1.216 0-2.232.272-3.048.816-.8.544-1.4 1.272-1.8 2.184l-.456-2.664h-4.2v13.92h4.992v-6.768Z"
        fill="#000"
        fillOpacity={0.2}
      />
    </svg>
  );
}

export function NearByParks(props: any) {
  return (
    <svg
      width={206}
      height={211}
      viewBox="0 0 206 211"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M81.875 0C34.99 0 0 24.093 0 68.504c0 42.145 32.526 63.429 69.686 68.139 35.794 4.555 53.052 16.031 59.079 37.575 5.882 20.955 18.331 36.093 38.677 36.093 23.725 0 38.558-25.62 38.558-86.186C206 53.565 149.75 0 81.875 0Z"
        fill="#FF7350"
      />
      <path
        d="M70.125 70.522c0-1.072.192-1.888.576-2.448.4-.576 1.064-.864 1.992-.864.896 0 1.504.264 1.824.792.336.512.504 1.248.504 2.208v7.08h4.944v-8.496c0-1.808-.456-3.216-1.368-4.224-.912-1.024-2.232-1.536-3.96-1.536-1.216 0-2.232.272-3.048.816-.8.544-1.4 1.272-1.8 2.184l-.456-2.665h-4.2v13.92h4.992v-6.767Zm19.82-3.912c.896 0 1.584.192 2.064.576.495.384.808.952.936 1.704h-6.24c.175-.736.528-1.296 1.055-1.68.528-.4 1.256-.6 2.184-.6Zm7.776 6.264h-5.257a2.24 2.24 0 0 1-.864.864c-.383.208-.935.312-1.655.312-.992 0-1.76-.2-2.304-.6-.529-.416-.857-1.016-.985-1.8h11.16v-1.464c0-1.344-.28-2.552-.84-3.624-.543-1.088-1.4-1.944-2.567-2.568a7.143 7.143 0 0 0-1.993-.72c-.736-.16-1.56-.24-2.471-.24-1.744 0-3.224.312-4.44.936-1.2.608-2.12 1.472-2.76 2.592a7.136 7.136 0 0 0-.697 1.8 8.49 8.49 0 0 0-.24 2.064v.24c0 1.392.264 2.616.792 3.672.529 1.056 1.377 1.88 2.544 2.472.576.304 1.248.528 2.016.672.769.144 1.624.216 2.569.216 2.272 0 4.055-.416 5.352-1.248 1.295-.832 2.175-2.024 2.64-3.576Zm8.199 1.464c-.56 0-.984-.088-1.272-.264-.272-.192-.408-.472-.408-.84v-.024c0-.208.048-.392.144-.552.096-.176.24-.328.432-.456.224-.128.512-.232.864-.312.352-.096.888-.192 1.608-.288.56-.096 1.024-.2 1.392-.312.368-.112.656-.256.864-.432v.576c0 .48-.16.944-.48 1.392-.32.448-.752.808-1.296 1.08-.272.144-.56.256-.864.336a4.775 4.775 0 0 1-.984.096Zm4.272 2.952h4.128v-8.616c0-1.856-.56-3.256-1.68-4.2-1.12-.96-2.944-1.44-5.472-1.44-2.4 0-4.256.48-5.568 1.44-1.296.944-2.016 2.272-2.16 3.984h5.016c.032-.608.264-1.072.696-1.392.448-.32 1.152-.48 2.112-.48.864 0 1.456.12 1.776.36.32.24.48.544.48.912 0 .4-.248.688-.744.864-.48.16-1.368.304-2.664.432-.912.112-1.68.224-2.304.336-.608.096-1.128.208-1.56.336-.208.08-.416.168-.624.264-.208.08-.416.176-.624.288-.64.352-1.136.816-1.488 1.392-.336.576-.504 1.28-.504 2.112 0 1.216.408 2.16 1.224 2.832.832.656 2.072.984 3.72.984 1.504 0 2.72-.28 3.648-.84.944-.56 1.64-1.264 2.088-2.112l.504 2.544Zm11.522 0v-5.448c0-.912.096-1.632.288-2.16a1.894 1.894 0 0 1 1.032-1.128c.256-.112.568-.192.936-.24a7.33 7.33 0 0 1 1.248-.096h1.944v-5.04h-1.08c-1.376 0-2.456.288-3.24.864-.768.56-1.28 1.44-1.536 2.64l-.624-3.313h-4.056v13.92h5.088Zm16.53.336c1.2 0 2.264-.272 3.192-.816.944-.56 1.688-1.376 2.232-2.448a7.004 7.004 0 0 0 .6-1.8c.144-.656.216-1.376.216-2.16v-.264c0-1.584-.264-2.896-.792-3.936-.512-1.04-1.232-1.824-2.16-2.352a5.983 5.983 0 0 0-1.488-.577 7.224 7.224 0 0 0-1.704-.191c-1.072 0-2.008.224-2.808.672a4.476 4.476 0 0 0-1.824 1.872v-6.768h-4.848V77.29h4.32l.312-2.232c.4.784.984 1.408 1.752 1.872.784.464 1.784.696 3 .696Zm-1.656-4.032c-.928 0-1.656-.264-2.184-.792-.528-.544-.792-1.36-.792-2.448v-.192c0-.992.264-1.768.792-2.328.544-.56 1.28-.84 2.208-.84.912 0 1.624.272 2.136.816.528.528.792 1.32.792 2.376v.216c0 1.088-.256 1.896-.768 2.424-.496.512-1.224.768-2.184.768Zm10.998 9.216c1.008 0 1.848-.064 2.52-.192.672-.112 1.248-.336 1.728-.672.48-.352.928-.856 1.344-1.512.416-.656.864-1.52 1.344-2.592l6.432-14.472h-5.064l-3.264 8.064-3.312-8.064h-5.208l6.024 13.224-.192.432c-.208.464-.424.824-.648 1.08a1.586 1.586 0 0 1-.84.528c-.16.064-.36.104-.6.12a5.48 5.48 0 0 1-.768.048h-1.944v4.008h2.448Zm-65.877 23.832c-.928 0-1.656-.264-2.184-.792-.512-.528-.768-1.296-.768-2.304v-.192c0-1.088.264-1.912.792-2.472s1.256-.84 2.184-.84c.928 0 1.648.272 2.16.816.528.528.792 1.36.792 2.496v.216c0 1.024-.248 1.792-.744 2.304-.496.512-1.24.768-2.232.768Zm1.68 3.936c1.152 0 2.2-.256 3.144-.768.944-.528 1.696-1.304 2.256-2.328a6.156 6.156 0 0 0 .624-1.752 9.96 9.96 0 0 0 .216-2.136v-.24c0-2.384-.56-4.192-1.68-5.424-1.12-1.232-2.632-1.848-4.536-1.848-1.184 0-2.184.248-3 .744a4.78 4.78 0 0 0-1.848 2.016l-.408-2.472h-4.176v18.72h4.848v-6.864c.4.736.968 1.312 1.704 1.728.736.416 1.688.624 2.856.624Zm14.387-3.24c-.56 0-.984-.088-1.272-.264-.272-.192-.408-.472-.408-.84v-.024c0-.208.048-.392.144-.552.096-.176.24-.328.432-.456.224-.128.512-.232.864-.312.352-.096.888-.192 1.608-.288.56-.096 1.024-.2 1.392-.312.368-.112.656-.256.864-.432v.576c0 .48-.16.944-.48 1.392-.32.448-.752.808-1.296 1.08-.272.144-.56.256-.864.336a4.775 4.775 0 0 1-.984.096Zm4.272 2.952h4.128v-8.616c0-1.856-.56-3.256-1.68-4.2-1.12-.96-2.944-1.44-5.472-1.44-2.4 0-4.256.48-5.568 1.44-1.296.944-2.016 2.272-2.16 3.984h5.016c.032-.608.264-1.072.696-1.392.448-.32 1.152-.48 2.112-.48.864 0 1.456.12 1.776.36.32.24.48.544.48.912 0 .4-.248.688-.744.864-.48.16-1.368.304-2.664.432-.912.112-1.68.224-2.304.336-.608.096-1.128.208-1.56.336-.208.08-.416.168-.624.264-.208.08-.416.176-.624.288-.64.352-1.136.816-1.488 1.392-.336.576-.504 1.28-.504 2.112 0 1.216.408 2.16 1.224 2.832.832.656 2.072.984 3.72.984 1.504 0 2.72-.28 3.648-.84.944-.56 1.64-1.264 2.088-2.112l.504 2.544Zm11.521 0v-5.448c0-.912.096-1.632.288-2.16a1.894 1.894 0 0 1 1.032-1.128c.256-.112.568-.192.936-.24a7.33 7.33 0 0 1 1.248-.096h1.944v-5.04h-1.08c-1.376 0-2.456.288-3.24.864-.768.56-1.28 1.44-1.536 2.64l-.624-3.313h-4.056v13.921h5.088Zm17.514 0h5.568l-5.28-8.568 5.088-5.352h-5.784l-5.112 5.376v-9.888h-4.848v18.432h4.848v-3.72l2.064-2.184 3.456 5.904Zm12.9.408c1.68 0 3.064-.208 4.152-.624 1.088-.432 1.888-1.016 2.4-1.752.272-.368.472-.76.6-1.176.128-.432.192-.888.192-1.368 0-1.04-.264-1.84-.792-2.4-.512-.576-1.24-.992-2.184-1.248-.464-.128-.976-.24-1.536-.336a19.15 19.15 0 0 0-1.8-.216c-1.264-.112-2.192-.232-2.784-.36-.576-.144-.864-.408-.864-.792 0-.32.152-.584.456-.793.304-.207.856-.311 1.656-.311.8 0 1.432.12 1.896.36.464.24.76.6.888 1.08h4.92c-.352-1.52-1.128-2.688-2.328-3.505-1.2-.832-2.96-1.247-5.28-1.247-2.272 0-3.992.44-5.16 1.32-1.152.864-1.728 2.008-1.728 3.432 0 1.04.256 1.848.768 2.424.528.56 1.256.96 2.184 1.2.464.128.968.24 1.512.336.544.08 1.12.144 1.728.192 1.248.096 2.176.216 2.784.36.608.128.912.4.912.816 0 .352-.176.632-.528.84-.336.208-.904.312-1.704.312-.896 0-1.584-.128-2.064-.384s-.808-.656-.984-1.2h-5.16c.272 1.696 1.072 2.96 2.4 3.792 1.344.832 3.16 1.248 5.448 1.248Z"
        fill="#2D2332"
      />
      <path
        d="M70.125 70.522c0-1.072.192-1.888.576-2.448.4-.576 1.064-.864 1.992-.864.896 0 1.504.264 1.824.792.336.512.504 1.248.504 2.208v7.08h4.944v-8.496c0-1.808-.456-3.216-1.368-4.224-.912-1.024-2.232-1.536-3.96-1.536-1.216 0-2.232.272-3.048.816-.8.544-1.4 1.272-1.8 2.184l-.456-2.665h-4.2v13.92h4.992v-6.767Zm19.82-3.912c.896 0 1.584.192 2.064.576.495.384.808.952.936 1.704h-6.24c.175-.736.528-1.296 1.055-1.68.528-.4 1.256-.6 2.184-.6Zm7.776 6.264h-5.257a2.24 2.24 0 0 1-.864.864c-.383.208-.935.312-1.655.312-.992 0-1.76-.2-2.304-.6-.529-.416-.857-1.016-.985-1.8h11.16v-1.464c0-1.344-.28-2.552-.84-3.624-.543-1.088-1.4-1.944-2.567-2.568a7.143 7.143 0 0 0-1.993-.72c-.736-.16-1.56-.24-2.471-.24-1.744 0-3.224.312-4.44.936-1.2.608-2.12 1.472-2.76 2.592a7.136 7.136 0 0 0-.697 1.8 8.49 8.49 0 0 0-.24 2.064v.24c0 1.392.264 2.616.792 3.672.529 1.056 1.377 1.88 2.544 2.472.576.304 1.248.528 2.016.672.769.144 1.624.216 2.569.216 2.272 0 4.055-.416 5.352-1.248 1.295-.832 2.175-2.024 2.64-3.576Zm8.199 1.464c-.56 0-.984-.088-1.272-.264-.272-.192-.408-.472-.408-.84v-.024c0-.208.048-.392.144-.552.096-.176.24-.328.432-.456.224-.128.512-.232.864-.312.352-.096.888-.192 1.608-.288.56-.096 1.024-.2 1.392-.312.368-.112.656-.256.864-.432v.576c0 .48-.16.944-.48 1.392-.32.448-.752.808-1.296 1.08-.272.144-.56.256-.864.336a4.775 4.775 0 0 1-.984.096Zm4.272 2.952h4.128v-8.616c0-1.856-.56-3.256-1.68-4.2-1.12-.96-2.944-1.44-5.472-1.44-2.4 0-4.256.48-5.568 1.44-1.296.944-2.016 2.272-2.16 3.984h5.016c.032-.608.264-1.072.696-1.392.448-.32 1.152-.48 2.112-.48.864 0 1.456.12 1.776.36.32.24.48.544.48.912 0 .4-.248.688-.744.864-.48.16-1.368.304-2.664.432-.912.112-1.68.224-2.304.336-.608.096-1.128.208-1.56.336-.208.08-.416.168-.624.264-.208.08-.416.176-.624.288-.64.352-1.136.816-1.488 1.392-.336.576-.504 1.28-.504 2.112 0 1.216.408 2.16 1.224 2.832.832.656 2.072.984 3.72.984 1.504 0 2.72-.28 3.648-.84.944-.56 1.64-1.264 2.088-2.112l.504 2.544Zm11.522 0v-5.448c0-.912.096-1.632.288-2.16a1.894 1.894 0 0 1 1.032-1.128c.256-.112.568-.192.936-.24a7.33 7.33 0 0 1 1.248-.096h1.944v-5.04h-1.08c-1.376 0-2.456.288-3.24.864-.768.56-1.28 1.44-1.536 2.64l-.624-3.313h-4.056v13.92h5.088Zm16.53.336c1.2 0 2.264-.272 3.192-.816.944-.56 1.688-1.376 2.232-2.448a7.004 7.004 0 0 0 .6-1.8c.144-.656.216-1.376.216-2.16v-.264c0-1.584-.264-2.896-.792-3.936-.512-1.04-1.232-1.824-2.16-2.352a5.983 5.983 0 0 0-1.488-.577 7.224 7.224 0 0 0-1.704-.191c-1.072 0-2.008.224-2.808.672a4.476 4.476 0 0 0-1.824 1.872v-6.768h-4.848V77.29h4.32l.312-2.232c.4.784.984 1.408 1.752 1.872.784.464 1.784.696 3 .696Zm-1.656-4.032c-.928 0-1.656-.264-2.184-.792-.528-.544-.792-1.36-.792-2.448v-.192c0-.992.264-1.768.792-2.328.544-.56 1.28-.84 2.208-.84.912 0 1.624.272 2.136.816.528.528.792 1.32.792 2.376v.216c0 1.088-.256 1.896-.768 2.424-.496.512-1.224.768-2.184.768Zm10.998 9.216c1.008 0 1.848-.064 2.52-.192.672-.112 1.248-.336 1.728-.672.48-.352.928-.856 1.344-1.512.416-.656.864-1.52 1.344-2.592l6.432-14.472h-5.064l-3.264 8.064-3.312-8.064h-5.208l6.024 13.224-.192.432c-.208.464-.424.824-.648 1.08a1.586 1.586 0 0 1-.84.528c-.16.064-.36.104-.6.12a5.48 5.48 0 0 1-.768.048h-1.944v4.008h2.448Zm-65.877 23.832c-.928 0-1.656-.264-2.184-.792-.512-.528-.768-1.296-.768-2.304v-.192c0-1.088.264-1.912.792-2.472s1.256-.84 2.184-.84c.928 0 1.648.272 2.16.816.528.528.792 1.36.792 2.496v.216c0 1.024-.248 1.792-.744 2.304-.496.512-1.24.768-2.232.768Zm1.68 3.936c1.152 0 2.2-.256 3.144-.768.944-.528 1.696-1.304 2.256-2.328a6.156 6.156 0 0 0 .624-1.752 9.96 9.96 0 0 0 .216-2.136v-.24c0-2.384-.56-4.192-1.68-5.424-1.12-1.232-2.632-1.848-4.536-1.848-1.184 0-2.184.248-3 .744a4.78 4.78 0 0 0-1.848 2.016l-.408-2.472h-4.176v18.72h4.848v-6.864c.4.736.968 1.312 1.704 1.728.736.416 1.688.624 2.856.624Zm14.387-3.24c-.56 0-.984-.088-1.272-.264-.272-.192-.408-.472-.408-.84v-.024c0-.208.048-.392.144-.552.096-.176.24-.328.432-.456.224-.128.512-.232.864-.312.352-.096.888-.192 1.608-.288.56-.096 1.024-.2 1.392-.312.368-.112.656-.256.864-.432v.576c0 .48-.16.944-.48 1.392-.32.448-.752.808-1.296 1.08-.272.144-.56.256-.864.336a4.775 4.775 0 0 1-.984.096Zm4.272 2.952h4.128v-8.616c0-1.856-.56-3.256-1.68-4.2-1.12-.96-2.944-1.44-5.472-1.44-2.4 0-4.256.48-5.568 1.44-1.296.944-2.016 2.272-2.16 3.984h5.016c.032-.608.264-1.072.696-1.392.448-.32 1.152-.48 2.112-.48.864 0 1.456.12 1.776.36.32.24.48.544.48.912 0 .4-.248.688-.744.864-.48.16-1.368.304-2.664.432-.912.112-1.68.224-2.304.336-.608.096-1.128.208-1.56.336-.208.08-.416.168-.624.264-.208.08-.416.176-.624.288-.64.352-1.136.816-1.488 1.392-.336.576-.504 1.28-.504 2.112 0 1.216.408 2.16 1.224 2.832.832.656 2.072.984 3.72.984 1.504 0 2.72-.28 3.648-.84.944-.56 1.64-1.264 2.088-2.112l.504 2.544Zm11.521 0v-5.448c0-.912.096-1.632.288-2.16a1.894 1.894 0 0 1 1.032-1.128c.256-.112.568-.192.936-.24a7.33 7.33 0 0 1 1.248-.096h1.944v-5.04h-1.08c-1.376 0-2.456.288-3.24.864-.768.56-1.28 1.44-1.536 2.64l-.624-3.313h-4.056v13.921h5.088Zm17.514 0h5.568l-5.28-8.568 5.088-5.352h-5.784l-5.112 5.376v-9.888h-4.848v18.432h4.848v-3.72l2.064-2.184 3.456 5.904Zm12.9.408c1.68 0 3.064-.208 4.152-.624 1.088-.432 1.888-1.016 2.4-1.752.272-.368.472-.76.6-1.176.128-.432.192-.888.192-1.368 0-1.04-.264-1.84-.792-2.4-.512-.576-1.24-.992-2.184-1.248-.464-.128-.976-.24-1.536-.336a19.15 19.15 0 0 0-1.8-.216c-1.264-.112-2.192-.232-2.784-.36-.576-.144-.864-.408-.864-.792 0-.32.152-.584.456-.793.304-.207.856-.311 1.656-.311.8 0 1.432.12 1.896.36.464.24.76.6.888 1.08h4.92c-.352-1.52-1.128-2.688-2.328-3.505-1.2-.832-2.96-1.247-5.28-1.247-2.272 0-3.992.44-5.16 1.32-1.152.864-1.728 2.008-1.728 3.432 0 1.04.256 1.848.768 2.424.528.56 1.256.96 2.184 1.2.464.128.968.24 1.512.336.544.08 1.12.144 1.728.192 1.248.096 2.176.216 2.784.36.608.128.912.4.912.816 0 .352-.176.632-.528.84-.336.208-.904.312-1.704.312-.896 0-1.584-.128-2.064-.384s-.808-.656-.984-1.2h-5.16c.272 1.696 1.072 2.96 2.4 3.792 1.344.832 3.16 1.248 5.448 1.248Z"
        fill="#000"
        fillOpacity={0.2}
      />
    </svg>
  );
}

export function ReadyToHost(props: any) {
  return (
    <svg
      width="166"
      height="166"
      viewBox="0 0 166 166"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M166 81.6167C166 136.95 139.717 166 84.3833 166C29.05 166 0 139.717 0 84.3833C0 29.05 26.2833 0 81.6167 0C136.95 0 166 26.2833 166 81.6167Z"
        fill="#FFA0BE"
      />
      <path
        d="M31.832 76.129V70.68c0-.912.096-1.632.288-2.16a1.894 1.894 0 011.032-1.128c.256-.112.568-.192.936-.24a7.33 7.33 0 011.248-.096h1.944v-5.04H36.2c-1.376 0-2.456.288-3.24.864-.768.56-1.28 1.44-1.536 2.64l-.624-3.312h-4.056v13.92h5.088zm14.52-10.68c.896 0 1.584.192 2.064.576.496.384.808.952.936 1.704h-6.24c.176-.736.528-1.296 1.056-1.68.528-.4 1.256-.6 2.184-.6zm7.776 6.264h-5.256a2.24 2.24 0 01-.864.864c-.384.208-.936.312-1.656.312-.992 0-1.76-.2-2.304-.6-.528-.416-.856-1.016-.984-1.8h11.16v-1.464c0-1.344-.28-2.552-.84-3.624-.544-1.088-1.4-1.944-2.568-2.568a7.14 7.14 0 00-1.992-.72c-.736-.16-1.56-.24-2.472-.24-1.744 0-3.224.312-4.44.936-1.2.608-2.12 1.472-2.76 2.592a7.136 7.136 0 00-.696 1.8 8.49 8.49 0 00-.24 2.064v.24c0 1.392.264 2.616.792 3.672s1.376 1.88 2.544 2.472c.576.304 1.248.528 2.016.672.768.144 1.624.216 2.568.216 2.272 0 4.056-.416 5.352-1.248 1.296-.832 2.176-2.024 2.64-3.576zm8.2 1.464c-.56 0-.984-.088-1.272-.264-.272-.192-.408-.472-.408-.84v-.024c0-.208.048-.392.144-.552.096-.176.24-.328.432-.456.224-.128.512-.232.864-.312.352-.096.888-.192 1.608-.288.56-.096 1.024-.2 1.392-.312.368-.112.656-.256.864-.432v.576c0 .48-.16.944-.48 1.392-.32.448-.752.808-1.296 1.08-.272.144-.56.256-.864.336a4.775 4.775 0 01-.984.096zm4.272 2.952h4.128v-8.616c0-1.856-.56-3.256-1.68-4.2-1.12-.96-2.944-1.44-5.472-1.44-2.4 0-4.256.48-5.568 1.44-1.296.944-2.016 2.272-2.16 3.984h5.016c.032-.608.264-1.072.696-1.392.448-.32 1.152-.48 2.112-.48.864 0 1.456.12 1.776.36.32.24.48.544.48.912 0 .4-.248.688-.744.864-.48.16-1.368.304-2.664.432-.912.112-1.68.224-2.304.336-.608.096-1.128.208-1.56.336-.208.08-.416.168-.624.264-.208.08-.416.176-.624.288-.64.352-1.136.816-1.488 1.392-.336.576-.504 1.28-.504 2.112 0 1.216.408 2.16 1.224 2.832.832.656 2.072.984 3.72.984 1.504 0 2.72-.28 3.648-.84.944-.56 1.64-1.264 2.088-2.112l.504 2.544zm13.824-3.696c-.928 0-1.648-.256-2.16-.768-.496-.512-.744-1.328-.744-2.448v-.192c0-1.072.248-1.872.744-2.4.496-.528 1.232-.792 2.208-.792.896 0 1.608.28 2.136.84.544.544.816 1.328.816 2.352v.192c0 1.072-.264 1.88-.792 2.424-.528.528-1.264.792-2.208.792zm3.504 3.696h4.248V57.697h-4.824v6.6a4.24 4.24 0 00-1.728-1.752c-.752-.416-1.688-.624-2.808-.624-1.216 0-2.296.264-3.24.792-.944.528-1.688 1.312-2.232 2.352a7.983 7.983 0 00-.6 1.776 11.299 11.299 0 00-.192 2.16v.24c0 1.584.264 2.912.792 3.984.528 1.056 1.256 1.856 2.184 2.4.464.256.96.448 1.488.576.544.144 1.12.216 1.728.216 1.232 0 2.24-.24 3.024-.72a4.749 4.749 0 001.776-1.992l.384 2.424zm8.628 5.52c1.008 0 1.848-.064 2.52-.192.672-.112 1.248-.336 1.728-.672.48-.352.928-.856 1.344-1.512.416-.656.864-1.52 1.344-2.592l6.432-14.472h-5.064l-3.264 8.064-3.312-8.064h-5.208L95.1 75.433l-.192.432c-.208.464-.424.824-.648 1.08a1.586 1.586 0 01-.84.528c-.16.064-.36.104-.6.12a5.48 5.48 0 01-.768.048h-1.944v4.008h2.448zm31.041-9.816h-1.488c-.72 0-1.264-.056-1.632-.168-.352-.128-.592-.384-.72-.768a3.56 3.56 0 01-.144-.72 10.215 10.215 0 01-.048-1.056v-2.712h4.032v-4.2h-4.032v-3.624h-3.936c-.016.336-.04.696-.072 1.08a5.26 5.26 0 01-.144 1.056c-.112.512-.272.88-.48 1.104-.192.224-.504.376-.936.456a7.076 7.076 0 01-.84.144c-.272.016-.584.032-.936.048v3.936h2.712v3.456c0 1.52.16 2.744.48 3.672.336.912.92 1.576 1.752 1.992.416.192.92.344 1.512.456.592.096 1.272.144 2.04.144h2.88v-4.296zm9.046 4.704c2.528 0 4.488-.616 5.88-1.848 1.408-1.248 2.112-3.008 2.112-5.28v-.24c0-1.552-.328-2.864-.984-3.936-.64-1.088-1.56-1.92-2.76-2.496a8.165 8.165 0 00-1.944-.648 11.02 11.02 0 00-2.256-.216c-1.584 0-2.976.288-4.176.864-1.184.576-2.112 1.408-2.784 2.496a7.22 7.22 0 00-.744 1.8 9.002 9.002 0 00-.24 2.136v.24c0 2.288.648 4.048 1.944 5.28 1.296 1.232 3.28 1.848 5.952 1.848zm.048-4.08c-.96 0-1.704-.256-2.232-.768-.512-.528-.768-1.296-.768-2.304v-.216c0-1.104.264-1.928.792-2.472.544-.544 1.288-.816 2.232-.816.992 0 1.736.272 2.232.816.496.544.744 1.368.744 2.472v.216c0 1.024-.264 1.792-.792 2.304-.512.512-1.248.768-2.208.768zm-74.32 29.904c0-1.072.2-1.896.6-2.472.4-.576 1.056-.864 1.968-.864.896 0 1.504.28 1.824.84.336.544.504 1.28.504 2.208v7.056h4.944v-8.52c0-1.808-.432-3.216-1.296-4.224-.864-1.008-2.176-1.512-3.936-1.512-1.088 0-2.024.24-2.808.72a4.833 4.833 0 00-1.824 1.896v-6.792h-4.872v18.432h4.896v-6.768zm19.581 7.176c2.528 0 4.488-.616 5.88-1.848 1.408-1.248 2.112-3.008 2.112-5.28v-.24c0-1.552-.328-2.864-.984-3.936-.64-1.088-1.56-1.92-2.76-2.496a8.165 8.165 0 00-1.944-.648A11.02 11.02 0 0078 94.873c-1.584 0-2.976.288-4.176.864-1.184.576-2.112 1.408-2.784 2.496a7.22 7.22 0 00-.744 1.8 9.002 9.002 0 00-.24 2.136v.24c0 2.288.648 4.048 1.944 5.28 1.296 1.232 3.28 1.848 5.952 1.848zm.048-4.08c-.96 0-1.704-.256-2.232-.768-.512-.528-.768-1.296-.768-2.304v-.216c0-1.104.264-1.928.792-2.472.544-.544 1.288-.816 2.232-.816.992 0 1.736.272 2.232.816.496.544.744 1.368.744 2.472v.216c0 1.024-.264 1.792-.792 2.304-.512.512-1.248.768-2.208.768zm16.649 4.08c1.68 0 3.064-.208 4.152-.624 1.088-.432 1.888-1.016 2.4-1.752.272-.368.472-.76.6-1.176.128-.432.192-.888.192-1.368 0-1.04-.264-1.84-.792-2.4-.512-.576-1.24-.992-2.184-1.248-.464-.128-.976-.24-1.536-.336a19.15 19.15 0 00-1.8-.216c-1.264-.112-2.192-.232-2.784-.36-.576-.144-.864-.408-.864-.792 0-.32.152-.584.456-.792.304-.208.856-.312 1.656-.312.8 0 1.432.12 1.896.36.464.24.76.6.888 1.08h4.92c-.352-1.52-1.128-2.688-2.328-3.504-1.2-.832-2.96-1.248-5.28-1.248-2.272 0-3.992.44-5.16 1.32-1.152.864-1.728 2.008-1.728 3.432 0 1.04.256 1.848.768 2.424.528.56 1.256.96 2.184 1.2.464.128.968.24 1.512.336.544.08 1.12.144 1.728.192 1.248.096 2.176.216 2.784.36.608.128.912.4.912.816 0 .352-.176.632-.528.84-.336.208-.904.312-1.704.312-.896 0-1.584-.128-2.064-.384s-.808-.656-.984-1.2H86.8c.272 1.696 1.072 2.96 2.4 3.792 1.344.832 3.16 1.248 5.448 1.248zm19.303-4.704h-1.488c-.72 0-1.264-.056-1.632-.168-.352-.128-.592-.384-.72-.768a3.56 3.56 0 01-.144-.72 10.215 10.215 0 01-.048-1.056v-2.712h4.032v-4.2h-4.032v-3.624h-3.936c-.016.336-.04.696-.072 1.08a5.26 5.26 0 01-.144 1.056c-.112.512-.272.88-.48 1.104-.192.224-.504.376-.936.456a7.076 7.076 0 01-.84.144c-.272.016-.584.032-.936.048v3.936h2.712v3.456c0 1.52.16 2.744.48 3.672.336.912.92 1.576 1.752 1.992.416.192.92.344 1.512.456.592.096 1.272.144 2.04.144h2.88v-4.296z"
        fill="#2D2332"
      />
      <path
        d="M31.832 76.129V70.68c0-.912.096-1.632.288-2.16a1.894 1.894 0 011.032-1.128c.256-.112.568-.192.936-.24a7.33 7.33 0 011.248-.096h1.944v-5.04H36.2c-1.376 0-2.456.288-3.24.864-.768.56-1.28 1.44-1.536 2.64l-.624-3.312h-4.056v13.92h5.088zm14.52-10.68c.896 0 1.584.192 2.064.576.496.384.808.952.936 1.704h-6.24c.176-.736.528-1.296 1.056-1.68.528-.4 1.256-.6 2.184-.6zm7.776 6.264h-5.256a2.24 2.24 0 01-.864.864c-.384.208-.936.312-1.656.312-.992 0-1.76-.2-2.304-.6-.528-.416-.856-1.016-.984-1.8h11.16v-1.464c0-1.344-.28-2.552-.84-3.624-.544-1.088-1.4-1.944-2.568-2.568a7.14 7.14 0 00-1.992-.72c-.736-.16-1.56-.24-2.472-.24-1.744 0-3.224.312-4.44.936-1.2.608-2.12 1.472-2.76 2.592a7.136 7.136 0 00-.696 1.8 8.49 8.49 0 00-.24 2.064v.24c0 1.392.264 2.616.792 3.672s1.376 1.88 2.544 2.472c.576.304 1.248.528 2.016.672.768.144 1.624.216 2.568.216 2.272 0 4.056-.416 5.352-1.248 1.296-.832 2.176-2.024 2.64-3.576zm8.2 1.464c-.56 0-.984-.088-1.272-.264-.272-.192-.408-.472-.408-.84v-.024c0-.208.048-.392.144-.552.096-.176.24-.328.432-.456.224-.128.512-.232.864-.312.352-.096.888-.192 1.608-.288.56-.096 1.024-.2 1.392-.312.368-.112.656-.256.864-.432v.576c0 .48-.16.944-.48 1.392-.32.448-.752.808-1.296 1.08-.272.144-.56.256-.864.336a4.775 4.775 0 01-.984.096zm4.272 2.952h4.128v-8.616c0-1.856-.56-3.256-1.68-4.2-1.12-.96-2.944-1.44-5.472-1.44-2.4 0-4.256.48-5.568 1.44-1.296.944-2.016 2.272-2.16 3.984h5.016c.032-.608.264-1.072.696-1.392.448-.32 1.152-.48 2.112-.48.864 0 1.456.12 1.776.36.32.24.48.544.48.912 0 .4-.248.688-.744.864-.48.16-1.368.304-2.664.432-.912.112-1.68.224-2.304.336-.608.096-1.128.208-1.56.336-.208.08-.416.168-.624.264-.208.08-.416.176-.624.288-.64.352-1.136.816-1.488 1.392-.336.576-.504 1.28-.504 2.112 0 1.216.408 2.16 1.224 2.832.832.656 2.072.984 3.72.984 1.504 0 2.72-.28 3.648-.84.944-.56 1.64-1.264 2.088-2.112l.504 2.544zm13.824-3.696c-.928 0-1.648-.256-2.16-.768-.496-.512-.744-1.328-.744-2.448v-.192c0-1.072.248-1.872.744-2.4.496-.528 1.232-.792 2.208-.792.896 0 1.608.28 2.136.84.544.544.816 1.328.816 2.352v.192c0 1.072-.264 1.88-.792 2.424-.528.528-1.264.792-2.208.792zm3.504 3.696h4.248V57.697h-4.824v6.6a4.24 4.24 0 00-1.728-1.752c-.752-.416-1.688-.624-2.808-.624-1.216 0-2.296.264-3.24.792-.944.528-1.688 1.312-2.232 2.352a7.983 7.983 0 00-.6 1.776 11.299 11.299 0 00-.192 2.16v.24c0 1.584.264 2.912.792 3.984.528 1.056 1.256 1.856 2.184 2.4.464.256.96.448 1.488.576.544.144 1.12.216 1.728.216 1.232 0 2.24-.24 3.024-.72a4.749 4.749 0 001.776-1.992l.384 2.424zm8.628 5.52c1.008 0 1.848-.064 2.52-.192.672-.112 1.248-.336 1.728-.672.48-.352.928-.856 1.344-1.512.416-.656.864-1.52 1.344-2.592l6.432-14.472h-5.064l-3.264 8.064-3.312-8.064h-5.208L95.1 75.433l-.192.432c-.208.464-.424.824-.648 1.08a1.586 1.586 0 01-.84.528c-.16.064-.36.104-.6.12a5.48 5.48 0 01-.768.048h-1.944v4.008h2.448zm31.041-9.816h-1.488c-.72 0-1.264-.056-1.632-.168-.352-.128-.592-.384-.72-.768a3.56 3.56 0 01-.144-.72 10.215 10.215 0 01-.048-1.056v-2.712h4.032v-4.2h-4.032v-3.624h-3.936c-.016.336-.04.696-.072 1.08a5.26 5.26 0 01-.144 1.056c-.112.512-.272.88-.48 1.104-.192.224-.504.376-.936.456a7.076 7.076 0 01-.84.144c-.272.016-.584.032-.936.048v3.936h2.712v3.456c0 1.52.16 2.744.48 3.672.336.912.92 1.576 1.752 1.992.416.192.92.344 1.512.456.592.096 1.272.144 2.04.144h2.88v-4.296zm9.046 4.704c2.528 0 4.488-.616 5.88-1.848 1.408-1.248 2.112-3.008 2.112-5.28v-.24c0-1.552-.328-2.864-.984-3.936-.64-1.088-1.56-1.92-2.76-2.496a8.165 8.165 0 00-1.944-.648 11.02 11.02 0 00-2.256-.216c-1.584 0-2.976.288-4.176.864-1.184.576-2.112 1.408-2.784 2.496a7.22 7.22 0 00-.744 1.8 9.002 9.002 0 00-.24 2.136v.24c0 2.288.648 4.048 1.944 5.28 1.296 1.232 3.28 1.848 5.952 1.848zm.048-4.08c-.96 0-1.704-.256-2.232-.768-.512-.528-.768-1.296-.768-2.304v-.216c0-1.104.264-1.928.792-2.472.544-.544 1.288-.816 2.232-.816.992 0 1.736.272 2.232.816.496.544.744 1.368.744 2.472v.216c0 1.024-.264 1.792-.792 2.304-.512.512-1.248.768-2.208.768zm-74.32 29.904c0-1.072.2-1.896.6-2.472.4-.576 1.056-.864 1.968-.864.896 0 1.504.28 1.824.84.336.544.504 1.28.504 2.208v7.056h4.944v-8.52c0-1.808-.432-3.216-1.296-4.224-.864-1.008-2.176-1.512-3.936-1.512-1.088 0-2.024.24-2.808.72a4.833 4.833 0 00-1.824 1.896v-6.792h-4.872v18.432h4.896v-6.768zm19.581 7.176c2.528 0 4.488-.616 5.88-1.848 1.408-1.248 2.112-3.008 2.112-5.28v-.24c0-1.552-.328-2.864-.984-3.936-.64-1.088-1.56-1.92-2.76-2.496a8.165 8.165 0 00-1.944-.648A11.02 11.02 0 0078 94.873c-1.584 0-2.976.288-4.176.864-1.184.576-2.112 1.408-2.784 2.496a7.22 7.22 0 00-.744 1.8 9.002 9.002 0 00-.24 2.136v.24c0 2.288.648 4.048 1.944 5.28 1.296 1.232 3.28 1.848 5.952 1.848zm.048-4.08c-.96 0-1.704-.256-2.232-.768-.512-.528-.768-1.296-.768-2.304v-.216c0-1.104.264-1.928.792-2.472.544-.544 1.288-.816 2.232-.816.992 0 1.736.272 2.232.816.496.544.744 1.368.744 2.472v.216c0 1.024-.264 1.792-.792 2.304-.512.512-1.248.768-2.208.768zm16.649 4.08c1.68 0 3.064-.208 4.152-.624 1.088-.432 1.888-1.016 2.4-1.752.272-.368.472-.76.6-1.176.128-.432.192-.888.192-1.368 0-1.04-.264-1.84-.792-2.4-.512-.576-1.24-.992-2.184-1.248-.464-.128-.976-.24-1.536-.336a19.15 19.15 0 00-1.8-.216c-1.264-.112-2.192-.232-2.784-.36-.576-.144-.864-.408-.864-.792 0-.32.152-.584.456-.792.304-.208.856-.312 1.656-.312.8 0 1.432.12 1.896.36.464.24.76.6.888 1.08h4.92c-.352-1.52-1.128-2.688-2.328-3.504-1.2-.832-2.96-1.248-5.28-1.248-2.272 0-3.992.44-5.16 1.32-1.152.864-1.728 2.008-1.728 3.432 0 1.04.256 1.848.768 2.424.528.56 1.256.96 2.184 1.2.464.128.968.24 1.512.336.544.08 1.12.144 1.728.192 1.248.096 2.176.216 2.784.36.608.128.912.4.912.816 0 .352-.176.632-.528.84-.336.208-.904.312-1.704.312-.896 0-1.584-.128-2.064-.384s-.808-.656-.984-1.2H86.8c.272 1.696 1.072 2.96 2.4 3.792 1.344.832 3.16 1.248 5.448 1.248zm19.303-4.704h-1.488c-.72 0-1.264-.056-1.632-.168-.352-.128-.592-.384-.72-.768a3.56 3.56 0 01-.144-.72 10.215 10.215 0 01-.048-1.056v-2.712h4.032v-4.2h-4.032v-3.624h-3.936c-.016.336-.04.696-.072 1.08a5.26 5.26 0 01-.144 1.056c-.112.512-.272.88-.48 1.104-.192.224-.504.376-.936.456a7.076 7.076 0 01-.84.144c-.272.016-.584.032-.936.048v3.936h2.712v3.456c0 1.52.16 2.744.48 3.672.336.912.92 1.576 1.752 1.992.416.192.92.344 1.512.456.592.096 1.272.144 2.04.144h2.88v-4.296z"
        fill="#000"
        fillOpacity={0.2}
      />
    </svg>
  );
}

export function BuyExportIcon(props: any) {
  return (
    <svg
      width={166}
      height={166}
      viewBox="0 0 166 166"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M140.104 108.897v-62.25H25.979v62.25h114.125zM67.479 108.897v36.354h31.125v-36.354M67.396 46.646V30.793L83.083 20.75l15.438 10.375v15.521"
        stroke="#FFA0BE"
        strokeWidth={18.8636434375}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function MoneyIcon(props: any) {
  return (
    <svg
      width={116}
      height={116}
      viewBox="0 0 116 116"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M105.125 29h-94.25a3.625 3.625 0 00-3.625 3.625v50.75A3.625 3.625 0 0010.875 87h94.25a3.625 3.625 0 003.625-3.625v-50.75A3.625 3.625 0 00105.125 29z"
        stroke="#FF7350"
        strokeWidth={10.875}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58 70.688c7.007 0 12.688-5.68 12.688-12.688 0-7.007-5.68-12.688-12.688-12.688-7.007 0-12.688 5.68-12.688 12.688 0 7.007 5.68 12.688 12.688 12.688zM76.125 29l32.625 29M76.125 87l32.625-29M39.875 29L7.25 58M39.875 87L7.25 58"
        stroke="#FF7350"
        strokeWidth={10.875}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
/* tslint:enable max-line-length */
